export interface IClassicTemplateTranslations {
  infoChoice: string;
  infoWishList: string;
  infoAge: string;
  infoReviews: string;
  infoOpen: string;
  infoLoading: string;
  infoInstall: string;
  descriptionTitle: string;
  descriptionMore: string;
  descriptionLess: string;
  changesTitle: string;
  chartsTitle: string;
  chartsTotal: string;
  additionalTitle: string;
  additionalUpdatedTitle: string;
  additionalSizeTitle: string;
  additionalInstallTitle: string;
  additionalVersionTitle: string;
  additionalAgeTitle: string;
  additionalDeveloperTitle: string;
  infoRatedFor: string;
  infoEditorsChoice: string;
  infoDownloads: string;
  infoDownload: string;
  infoAboutGame: string;
  infoDataSafety: string;
  infoDataSafetyDescription: string;
  infoDataSharing: string;
  infoDataSharingLearnMore1: string;
  infoDataSharingLearnMore2: string;
  infoDataCollecting: string;
  infoDataCollectingLearnMore1: string;
  infoDataCollectingLearnMore2: string;
  infoSeeDetails: string;
  ratingsDescription: string;
  ratingLikes: string;
  ratingQuestion: string;
  ratingQuestionYes: string;
  ratingQuestionNo: string;
  ratingAllReviews: string;
  addToWishlist: string;
  detailsSupport: string;
  detailsPrivacyPolicy: string;
  googlePlayRefund: string;
  googlePlayVAT: string;
  googlePlayGames: string;
  googlePlayApps: string;
  googlePlaySearch: string;
  googlePlayBooks: string;
  appAvailability: string;
}

export type IClassicTemplateTexts = Record<string, IClassicTemplateTranslations>;

export const CLASSIC_TEMPLATE_TEXTS: IClassicTemplateTexts = {
  en: {
    infoChoice: "Editor's choice",
    infoWishList: 'Add to Wishlist',
    infoAge: 'Age',
    infoRatedFor: 'Rated for',
    infoReviews: 'reviews',
    appAvailability: 'This app is available for all of your devices',
    infoOpen: 'Open',
    infoLoading: 'Loading...',
    infoDownloads: 'Downloads',
    infoInstall: 'Install',
    addToWishlist: 'Add to wishlist',
    infoDownload: 'Download',
    infoEditorsChoice: "Editors' Choice",
    infoAboutGame: 'About this game',
    infoDataSafety: 'Data safety',
    infoDataSafetyDescription:
      'Safety starts with understanding how developers collect and share your data. Data privacy and security practices may vary based on your use, region, and age. The developer provided this information and may update it over time.',
    infoDataSharing: 'No data shared with third parties',
    infoDataSharingLearnMore1: 'Learn more',
    infoDataSharingLearnMore2: 'about how developers declare sharing',
    infoDataCollecting: 'No data collected',
    infoDataCollectingLearnMore1: 'Learn more',
    infoDataCollectingLearnMore2: 'about how developers declare collection',
    infoSeeDetails: 'See details',
    descriptionTitle: 'About the App',
    descriptionMore: 'More...',
    descriptionLess: 'Less',
    changesTitle: "What's New",
    chartsTitle: 'Ratings and Reviews',
    ratingsDescription:
      'Ratings and reviews are verified and are from people who use the same type of device that you use',
    ratingLikes: 'people found this helpful',
    ratingQuestion: 'Was this review helpful?',
    ratingQuestionYes: 'Yes',
    ratingQuestionNo: 'No',
    ratingAllReviews: 'See all reviews',
    chartsTotal: 'Total',
    additionalTitle: 'Additional Information',
    additionalUpdatedTitle: 'Updated',
    additionalSizeTitle: 'Size',
    additionalInstallTitle: 'Installations',
    additionalVersionTitle: 'Current Version',
    additionalAgeTitle: 'Age',
    additionalDeveloperTitle: 'Developer',
    detailsSupport: 'App support',
    detailsPrivacyPolicy: 'Privacy policy',
    googlePlayRefund: 'Google Play refund policy',
    googlePlayVAT: 'All prices include VAT.',
    googlePlayGames: 'Games',
    googlePlayApps: 'Apps',
    googlePlaySearch: 'Search',
    googlePlayBooks: 'Books',
  },
  es: {
    infoChoice: 'Selección del editor',
    infoWishList: 'Agregar a la lista de deseos',
    infoAge: 'Edad',
    infoRatedFor: 'Clasificado para',
    infoReviews: 'reseñas',
    appAvailability: 'Esta aplicación está disponible para todos tus dispositivos',
    infoOpen: 'Abrir',
    infoLoading: 'Cargando...',
    infoDownloads: 'Descargas',
    infoInstall: 'Instalar',
    addToWishlist: 'Agregar a la lista de deseos',
    infoDownload: 'Descargar',
    infoEditorsChoice: 'Selección de los editores',
    infoAboutGame: 'Acerca de este juego',
    infoDataSafety: 'Seguridad de los datos',
    infoDataSafetyDescription:
      'La seguridad comienza con entender cómo los desarrolladores recopilan y comparten tus datos. Las prácticas de privacidad y seguridad pueden variar según tu uso, región y edad. El desarrollador proporcionó esta información y puede actualizarla con el tiempo.',
    infoDataSharing: 'No se comparten datos con terceros',
    infoDataSharingLearnMore1: 'Más información',
    infoDataSharingLearnMore2: 'sobre cómo los desarrolladores declaran compartir',
    infoDataCollecting: 'No se recopilan datos',
    infoDataCollectingLearnMore1: 'Más información',
    infoDataCollectingLearnMore2: 'sobre cómo los desarrolladores declaran la recopilación',
    infoSeeDetails: 'Ver detalles',
    descriptionTitle: 'Acerca de la aplicación',
    descriptionMore: 'Más...',
    descriptionLess: 'Menos',
    changesTitle: 'Novedades',
    chartsTitle: 'Calificaciones y reseñas',
    ratingsDescription:
      'Las calificaciones y reseñas están verificadas y provienen de personas que usan el mismo tipo de dispositivo que tú',
    ratingLikes: 'personas encontraron esto útil',
    ratingQuestion: '¿Fue útil esta reseña?',
    ratingQuestionYes: 'Sí',
    ratingQuestionNo: 'No',
    ratingAllReviews: 'Ver todas las reseñas',
    chartsTotal: 'Total',
    additionalTitle: 'Información adicional',
    additionalUpdatedTitle: 'Actualizado',
    additionalSizeTitle: 'Tamaño',
    additionalInstallTitle: 'Instalaciones',
    additionalVersionTitle: 'Versión actual',
    additionalAgeTitle: 'Edad',
    additionalDeveloperTitle: 'Desarrollador',
    detailsSupport: 'Soporte de la aplicación',
    detailsPrivacyPolicy: 'Política de privacidad',
    googlePlayRefund: 'Política de reembolso de Google Play',
    googlePlayVAT: 'Todos los precios incluyen IVA.',
    googlePlayGames: 'Juegos',
    googlePlayApps: 'Aplicaciones',
    googlePlaySearch: 'Buscar',
    googlePlayBooks: 'Libros',
  },
  uk: {
    infoChoice: 'Вибір редакції',
    infoWishList: 'Додати до списку бажань',
    infoAge: 'Вік',
    infoRatedFor: 'Призначено для',
    infoReviews: 'відгуки',
    appAvailability: 'Цей застосунок доступний для всіх ваших пристроїв',
    infoOpen: 'Відкрити',
    infoLoading: 'Завантаження...',
    infoDownloads: 'Завантаження',
    infoInstall: 'Встановити',
    addToWishlist: 'Додати до списку бажань',
    infoDownload: 'Завантажити',
    infoEditorsChoice: 'Вибір редакторів',
    infoAboutGame: 'Про цю гру',
    infoDataSafety: 'Безпека даних',
    infoDataSafetyDescription:
      'Безпека починається з розуміння того, як розробники збирають і поширюють ваші дані. Політики конфіденційності та безпеки можуть відрізнятися залежно від використання, регіону та віку. Розробник надав цю інформацію і може оновлювати її з часом.',
    infoDataSharing: 'Дані не передаються третім сторонам',
    infoDataSharingLearnMore1: 'Дізнатися більше',
    infoDataSharingLearnMore2: 'про те, як розробники декларують обмін',
    infoDataCollecting: 'Дані не збираються',
    infoDataCollectingLearnMore1: 'Дізнатися більше',
    infoDataCollectingLearnMore2: 'про те, як розробники декларують збір',
    infoSeeDetails: 'Переглянути деталі',
    descriptionTitle: 'Про застосунок',
    descriptionMore: 'Більше...',
    descriptionLess: 'Менше',
    changesTitle: 'Що нового',
    chartsTitle: 'Оцінки та відгуки',
    ratingsDescription:
      'Оцінки та відгуки перевірені й належать людям, які користуються тим самим типом пристрою, що й ви',
    ratingLikes: 'людей вважають це корисним',
    ratingQuestion: 'Чи був цей відгук корисним?',
    ratingQuestionYes: 'Так',
    ratingQuestionNo: 'Ні',
    ratingAllReviews: 'Переглянути всі відгуки',
    chartsTotal: 'Усього',
    additionalTitle: 'Додаткова інформація',
    additionalUpdatedTitle: 'Оновлено',
    additionalSizeTitle: 'Розмір',
    additionalInstallTitle: 'Встановлення',
    additionalVersionTitle: 'Поточна версія',
    additionalAgeTitle: 'Вік',
    additionalDeveloperTitle: 'Розробник',
    detailsSupport: 'Підтримка застосунку',
    detailsPrivacyPolicy: 'Політика конфіденційності',
    googlePlayRefund: 'Політика відшкодувань Google Play',
    googlePlayVAT: 'Усі ціни включають ПДВ.',
    googlePlayGames: 'Ігри',
    googlePlayApps: 'Додатки',
    googlePlaySearch: 'Пошук',
    googlePlayBooks: 'Книги',
  },
  it: {
    infoChoice: "Scelta dell'editor",
    infoWishList: 'Aggiungi alla lista dei desideri',
    infoAge: 'Età',
    infoRatedFor: 'Classificato per',
    infoReviews: 'recensioni',
    appAvailability: 'Questa app è disponibile per tutti i tuoi dispositivi',
    infoOpen: 'Apri',
    infoLoading: 'Caricamento...',
    infoDownloads: 'Download',
    infoInstall: 'Installa',
    addToWishlist: 'Aggiungi alla lista dei desideri',
    infoDownload: 'Scarica',
    infoEditorsChoice: 'Scelta degli editor',
    infoAboutGame: 'Informazioni su questo gioco',
    infoDataSafety: 'Sicurezza dei dati',
    infoDataSafetyDescription:
      "La sicurezza inizia comprendendo come gli sviluppatori raccolgono e condividono i tuoi dati. Le pratiche di privacy e sicurezza possono variare in base al tuo utilizzo, alla regione e all'età. Lo sviluppatore ha fornito queste informazioni e può aggiornarle nel tempo.",
    infoDataSharing: 'Nessun dato condiviso con terze parti',
    infoDataSharingLearnMore1: 'Scopri di più',
    infoDataSharingLearnMore2: 'su come gli sviluppatori dichiarano la condivisione',
    infoDataCollecting: 'Nessun dato raccolto',
    infoDataCollectingLearnMore1: 'Scopri di più',
    infoDataCollectingLearnMore2: 'su come gli sviluppatori dichiarano la raccolta',
    infoSeeDetails: 'Vedi dettagli',
    descriptionTitle: "Informazioni sull'app",
    descriptionMore: 'Altro...',
    descriptionLess: 'Meno',
    changesTitle: 'Novità',
    chartsTitle: 'Valutazioni e recensioni',
    ratingsDescription:
      'Le valutazioni e recensioni sono verificate e provengono da persone che utilizzano lo stesso tipo di dispositivo che usi tu',
    ratingLikes: 'persone hanno trovato utile questo',
    ratingQuestion: 'Questa recensione è stata utile?',
    ratingQuestionYes: 'Sì',
    ratingQuestionNo: 'No',
    ratingAllReviews: 'Vedi tutte le recensioni',
    chartsTotal: 'Totale',
    additionalTitle: 'Informazioni aggiuntive',
    additionalUpdatedTitle: 'Aggiornato',
    additionalSizeTitle: 'Dimensione',
    additionalInstallTitle: 'Installazioni',
    additionalVersionTitle: 'Versione attuale',
    additionalAgeTitle: 'Età',
    additionalDeveloperTitle: 'Sviluppatore',
    detailsSupport: 'Supporto app',
    detailsPrivacyPolicy: 'Informativa sulla privacy',
    googlePlayRefund: 'Politica di rimborso di Google Play',
    googlePlayVAT: 'Tutti i prezzi includono IVA.',
    googlePlayGames: 'Giochi',
    googlePlayApps: 'App',
    googlePlaySearch: 'Cerca',
    googlePlayBooks: 'Libri',
  },
  zh: {
    appAvailability: '此应用适用于您所有的设备',
    addToWishlist: '添加到愿望清单',
    infoChoice: '编辑推荐',
    infoWishList: '添加到愿望清单',
    infoAge: '年龄',
    infoRatedFor: '适合于',
    infoReviews: '条评论',
    infoOpen: '打开',
    infoLoading: '加载中...',
    infoDownloads: '下载次数',
    infoInstall: '安装',
    infoDownload: '下载',
    infoEditorsChoice: '编辑精选',
    infoAboutGame: '关于此游戏',
    infoDataSafety: '数据安全',
    infoDataSafetyDescription:
      '安全始于了解开发者如何收集和共享您的数据。数据隐私和安全措施可能因您的使用、地区和年龄而异。开发者提供了此信息，并可能随时间更新。',
    infoDataSharing: '未与第三方共享数据',
    infoDataSharingLearnMore1: '了解更多',
    infoDataSharingLearnMore2: '关于开发者如何声明共享',
    infoDataCollecting: '未收集任何数据',
    infoDataCollectingLearnMore1: '了解更多',
    infoDataCollectingLearnMore2: '关于开发者如何声明收集',
    infoSeeDetails: '查看详情',
    descriptionTitle: '关于应用',
    descriptionMore: '更多...',
    descriptionLess: '收起',
    changesTitle: '最新更新',
    chartsTitle: '评分和评论',
    ratingsDescription: '评分和评论已验证，来自使用与您相同类型设备的用户',
    ratingLikes: '人觉得有帮助',
    ratingQuestion: '此评论对您有帮助吗？',
    ratingQuestionYes: '是',
    ratingQuestionNo: '否',
    ratingAllReviews: '查看所有评论',
    chartsTotal: '总计',
    additionalTitle: '附加信息',
    additionalUpdatedTitle: '更新日期',
    additionalSizeTitle: '大小',
    additionalInstallTitle: '安装次数',
    additionalVersionTitle: '当前版本',
    additionalAgeTitle: '适龄',
    additionalDeveloperTitle: '开发者',
    detailsSupport: '应用支持',
    detailsPrivacyPolicy: '隐私政策',
    googlePlayRefund: 'Google Play 退款政策',
    googlePlayVAT: '所有价格均含增值税。',
    googlePlayGames: '游戏',
    googlePlayApps: '应用',
    googlePlaySearch: '搜索',
    googlePlayBooks: '图书',
  },
  hi: {
    appAvailability: 'यह ऐप आपके सभी डिवाइसों के लिए उपलब्ध है',
    addToWishlist: 'इच्छा सूची में जोड़ें',
    infoChoice: 'संपादक की पसंद',
    infoWishList: 'इच्छा सूची में जोड़ें',
    infoAge: 'आयु',
    infoRatedFor: 'के लिए रेटेड',
    infoReviews: 'समीक्षाएँ',
    infoOpen: 'खोलें',
    infoLoading: 'लोड हो रहा है...',
    infoDownloads: 'डाउनलोड्स',
    infoInstall: 'इंस्टॉल करें',
    infoDownload: 'डाउनलोड',
    infoEditorsChoice: 'संपादक की चयन',
    infoAboutGame: 'इस गेम के बारे में',
    infoDataSafety: 'डेटा सुरक्षा',
    infoDataSafetyDescription:
      'सुरक्षा इस बात को समझने से शुरू होती है कि डेवलपर्स आपके डेटा को कैसे एकत्र और साझा करते हैं। डेटा गोपनीयता और सुरक्षा प्रथाएँ आपके उपयोग, क्षेत्र और आयु के आधार पर भिन्न हो सकती हैं। डेवलपर ने यह जानकारी दी है और समय-समय पर इसे अपडेट कर सकता है।',
    infoDataSharing: 'कोई डेटा तृतीय पक्षों के साथ साझा नहीं किया गया',
    infoDataSharingLearnMore1: 'और जानें',
    infoDataSharingLearnMore2: 'कैसे डेवलपर्स साझा करना घोषित करते हैं',
    infoDataCollecting: 'कोई डेटा एकत्र नहीं किया गया',
    infoDataCollectingLearnMore1: 'और जानें',
    infoDataCollectingLearnMore2: 'कैसे डेवलपर्स संग्रहण घोषित करते हैं',
    infoSeeDetails: 'विवरण देखें',
    descriptionTitle: 'ऐप के बारे में',
    descriptionMore: 'और...',
    descriptionLess: 'कम',
    changesTitle: 'क्या नया है',
    chartsTitle: 'रेटिंग और समीक्षाएँ',
    ratingsDescription:
      'रेटिंग और समीक्षाएँ सत्यापित हैं और उन लोगों से हैं जो आपके समान प्रकार के डिवाइस का उपयोग करते हैं',
    ratingLikes: 'लोगों को यह सहायक लगा',
    ratingQuestion: 'क्या यह समीक्षा सहायक थी?',
    ratingQuestionYes: 'हाँ',
    ratingQuestionNo: 'नहीं',
    ratingAllReviews: 'सभी समीक्षाएँ देखें',
    chartsTotal: 'कुल',
    additionalTitle: 'अतिरिक्त जानकारी',
    additionalUpdatedTitle: 'अद्यतन',
    additionalSizeTitle: 'आकार',
    additionalInstallTitle: 'इंस्टॉलेशन',
    additionalVersionTitle: 'वर्तमान संस्करण',
    additionalAgeTitle: 'आयु',
    additionalDeveloperTitle: 'डेवलपर',
    detailsSupport: 'ऐप समर्थन',
    detailsPrivacyPolicy: 'गोपनीयता नीति',
    googlePlayRefund: 'Google Play रिफंड नीति',
    googlePlayVAT: 'सभी कीमतों में जीएसटी शामिल है।',
    googlePlayGames: 'गेम्स',
    googlePlayApps: 'ऐप्स',
    googlePlaySearch: 'खोजें',
    googlePlayBooks: 'पुस्तकें',
  },
  ar: {
    appAvailability: 'هذا التطبيق متاح لجميع أجهزتك',
    addToWishlist: 'أضف إلى قائمة الرغبات',
    infoChoice: 'اختيار المحررين',
    infoWishList: 'أضف إلى قائمة الرغبات',
    infoAge: 'العمر',
    infoRatedFor: 'مناسب لـ',
    infoReviews: 'المراجعات',
    infoOpen: 'فتح',
    infoLoading: 'جارٍ التحميل...',
    infoDownloads: 'التنزيلات',
    infoInstall: 'تثبيت',
    infoDownload: 'تنزيل',
    infoEditorsChoice: 'اختيار المحررين',
    infoAboutGame: 'حول هذه اللعبة',
    infoDataSafety: 'أمان البيانات',
    infoDataSafetyDescription:
      'يبدأ الأمان بفهم كيفية جمع المطورين لبياناتك ومشاركتها. قد تختلف ممارسات الخصوصية والأمان حسب استخدامك ومنطقتك وعمرك. قدم المطور هذه المعلومات وقد يقوم بتحديثها مع مرور الوقت.',
    infoDataSharing: 'لا تتم مشاركة البيانات مع أطراف ثالثة',
    infoDataSharingLearnMore1: 'اعرف المزيد',
    infoDataSharingLearnMore2: 'حول كيفية إعلان المطورين عن المشاركة',
    infoDataCollecting: 'لا يتم جمع أي بيانات',
    infoDataCollectingLearnMore1: 'اعرف المزيد',
    infoDataCollectingLearnMore2: 'حول كيفية إعلان المطورين عن الجمع',
    infoSeeDetails: 'عرض التفاصيل',
    descriptionTitle: 'حول التطبيق',
    descriptionMore: 'المزيد...',
    descriptionLess: 'أقل',
    changesTitle: 'ما الجديد',
    chartsTitle: 'التقييمات والمراجعات',
    ratingsDescription: 'التقييمات والمراجعات تم التحقق منها وتأتي من أشخاص يستخدمون نفس نوع الجهاز الذي تستخدمه',
    ratingLikes: 'أشخاص وجدوا هذا مفيدًا',
    ratingQuestion: 'هل كانت هذه المراجعة مفيدة؟',
    ratingQuestionYes: 'نعم',
    ratingQuestionNo: 'لا',
    ratingAllReviews: 'عرض جميع المراجعات',
    chartsTotal: 'الإجمالي',
    additionalTitle: 'معلومات إضافية',
    additionalUpdatedTitle: 'تم التحديث',
    additionalSizeTitle: 'الحجم',
    additionalInstallTitle: 'التثبيتات',
    additionalVersionTitle: 'الإصدار الحالي',
    additionalAgeTitle: 'العمر',
    additionalDeveloperTitle: 'المطور',
    detailsSupport: 'دعم التطبيق',
    detailsPrivacyPolicy: 'سياسة الخصوصية',
    googlePlayRefund: 'سياسة استرداد Google Play',
    googlePlayVAT: 'جميع الأسعار تشمل ضريبة القيمة المضافة.',
    googlePlayGames: 'ألعاب',
    googlePlayApps: 'تطبيقات',
    googlePlaySearch: 'بحث',
    googlePlayBooks: 'كتب',
  },
  bn: {
    appAvailability: 'এই অ্যাপটি আপনার সব ডিভাইসে উপলব্ধ',
    addToWishlist: 'ইচ্ছেতালিকায় যোগ করুন',
    infoChoice: 'সম্পাদকের পছন্দ',
    infoWishList: 'ইচ্ছেতালিকায় যোগ করুন',
    infoAge: 'বয়স',
    infoRatedFor: 'যাদের জন্য রেট করা হয়েছে',
    infoReviews: 'রিভিউ',
    infoOpen: 'খুলুন',
    infoLoading: 'লোড হচ্ছে...',
    infoDownloads: 'ডাউনলোড',
    infoInstall: 'ইনস্টল করুন',
    infoDownload: 'ডাউনলোড',
    infoEditorsChoice: 'সম্পাদকের নির্বাচন',
    infoAboutGame: 'এই গেম সম্পর্কে',
    infoDataSafety: 'ডেটা সুরক্ষা',
    infoDataSafetyDescription:
      'নিরাপত্তা শুরু হয় এই বোঝা থেকে যে ডেভেলপাররা কিভাবে আপনার ডেটা সংগ্রহ ও শেয়ার করে। আপনার ব্যবহার, অঞ্চল এবং বয়স অনুযায়ী ডেটা গোপনীয়তা ও সুরক্ষা অনুশীলন পরিবর্তিত হতে পারে। ডেভেলপার এই তথ্য প্রদান করেছে এবং সময়ে সময়ে এটি আপডেট করতে পারে।',
    infoDataSharing: 'কোনও ডেটা তৃতীয় পক্ষের সাথে শেয়ার করা হয়নি',
    infoDataSharingLearnMore1: 'আরও জানুন',
    infoDataSharingLearnMore2: 'ডেভেলপাররা শেয়ারিং কীভাবে ঘোষণা করে',
    infoDataCollecting: 'কোনও ডেটা সংগ্রহ করা হয়নি',
    infoDataCollectingLearnMore1: 'আরও জানুন',
    infoDataCollectingLearnMore2: 'ডেভেলপাররা সংগ্রহ কীভাবে ঘোষণা করে',
    infoSeeDetails: 'বিস্তারিত দেখুন',
    descriptionTitle: 'অ্যাপ সম্পর্কে',
    descriptionMore: 'আরও...',
    descriptionLess: 'কম',
    changesTitle: 'নতুন কী',
    chartsTitle: 'রেটিং এবং রিভিউ',
    ratingsDescription: 'রেটিং এবং রিভিউ যাচাই করা হয়েছে এবং আপনার মতো একই ধরনের ডিভাইস ব্যবহারকারীদের থেকে এসেছে',
    ratingLikes: 'মানুষ এটি সহায়ক মনে করেছেন',
    ratingQuestion: 'এই রিভিউটি কি সহায়ক ছিল?',
    ratingQuestionYes: 'হ্যাঁ',
    ratingQuestionNo: 'না',
    ratingAllReviews: 'সব রিভিউ দেখুন',
    chartsTotal: 'মোট',
    additionalTitle: 'অতিরিক্ত তথ্য',
    additionalUpdatedTitle: 'আপডেট করা হয়েছে',
    additionalSizeTitle: 'আকার',
    additionalInstallTitle: 'ইনস্টলেশন',
    additionalVersionTitle: 'বর্তমান সংস্করণ',
    additionalAgeTitle: 'বয়স',
    additionalDeveloperTitle: 'ডেভেলপার',
    detailsSupport: 'অ্যাপ সাপোর্ট',
    detailsPrivacyPolicy: 'গোপনীয়তা নীতি',
    googlePlayRefund: 'Google Play ফেরত নীতি',
    googlePlayVAT: 'সব দামে ভ্যাট অন্তর্ভুক্ত।',
    googlePlayGames: 'গেমস',
    googlePlayApps: 'অ্যাপস',
    googlePlaySearch: 'অনুসন্ধান',
    googlePlayBooks: 'বই',
  },
  pt: {
    appAvailability: 'Este app está disponível para todos os seus dispositivos',
    addToWishlist: 'Adicionar à lista de desejos',
    infoChoice: 'Escolha do editor',
    infoWishList: 'Adicionar à lista de desejos',
    infoAge: 'Idade',
    infoRatedFor: 'Classificado para',
    infoReviews: 'avaliações',
    infoOpen: 'Abrir',
    infoLoading: 'Carregando...',
    infoDownloads: 'Downloads',
    infoInstall: 'Instalar',
    infoDownload: 'Baixar',
    infoEditorsChoice: 'Escolha dos editores',
    infoAboutGame: 'Sobre este jogo',
    infoDataSafety: 'Segurança de dados',
    infoDataSafetyDescription:
      'A segurança começa entendendo como os desenvolvedores coletam e compartilham seus dados. As práticas de privacidade e segurança podem variar com base no uso, região e idade. O desenvolvedor forneceu essas informações e pode atualizá-las ao longo do tempo.',
    infoDataSharing: 'Nenhum dado compartilhado com terceiros',
    infoDataSharingLearnMore1: 'Saiba mais',
    infoDataSharingLearnMore2: 'sobre como os desenvolvedores declaram compartilhamento',
    infoDataCollecting: 'Nenhum dado coletado',
    infoDataCollectingLearnMore1: 'Saiba mais',
    infoDataCollectingLearnMore2: 'sobre como os desenvolvedores declaram coleta',
    infoSeeDetails: 'Ver detalhes',
    descriptionTitle: 'Sobre o aplicativo',
    descriptionMore: 'Mais...',
    descriptionLess: 'Menos',
    changesTitle: 'Novidades',
    chartsTitle: 'Avaliações e resenhas',
    ratingsDescription:
      'As avaliações e resenhas são verificadas e vêm de pessoas que usam o mesmo tipo de dispositivo que você',
    ratingLikes: 'pessoas acharam isso útil',
    ratingQuestion: 'Esta avaliação foi útil?',
    ratingQuestionYes: 'Sim',
    ratingQuestionNo: 'Não',
    ratingAllReviews: 'Ver todas as avaliações',
    chartsTotal: 'Total',
    additionalTitle: 'Informações adicionais',
    additionalUpdatedTitle: 'Atualizado',
    additionalSizeTitle: 'Tamanho',
    additionalInstallTitle: 'Instalações',
    additionalVersionTitle: 'Versão atual',
    additionalAgeTitle: 'Idade',
    additionalDeveloperTitle: 'Desenvolvedor',
    detailsSupport: 'Suporte do app',
    detailsPrivacyPolicy: 'Política de privacidade',
    googlePlayRefund: 'Política de reembolso do Google Play',
    googlePlayVAT: 'Todos os preços incluem impostos.',
    googlePlayGames: 'Jogos',
    googlePlayApps: 'Apps',
    googlePlaySearch: 'Pesquisar',
    googlePlayBooks: 'Livros',
  },
  ru: {
    appAvailability: 'Это приложение доступно для всех ваших устройств',
    addToWishlist: 'Добавить в список желаний',
    infoChoice: 'Выбор редакции',
    infoWishList: 'Добавить в список желаний',
    infoAge: 'Возраст',
    infoRatedFor: 'Предназначено для',
    infoReviews: 'отзывов',
    infoOpen: 'Открыть',
    infoLoading: 'Загрузка...',
    infoDownloads: 'Загрузки',
    infoInstall: 'Установить',
    infoDownload: 'Скачать',
    infoEditorsChoice: 'Выбор редакторов',
    infoAboutGame: 'Об этой игре',
    infoDataSafety: 'Безопасность данных',
    infoDataSafetyDescription:
      'Безопасность начинается с понимания того, как разработчики собирают и обмениваются вашими данными. Практики конфиденциальности и безопасности могут различаться в зависимости от вашего использования, региона и возраста. Разработчик предоставил эту информацию и может обновлять её со временем.',
    infoDataSharing: 'Данные не передаются третьим сторонам',
    infoDataSharingLearnMore1: 'Подробнее',
    infoDataSharingLearnMore2: 'о том, как разработчики заявляют об обмене',
    infoDataCollecting: 'Данные не собираются',
    infoDataCollectingLearnMore1: 'Подробнее',
    infoDataCollectingLearnMore2: 'о том, как разработчики заявляют о сборе',
    infoSeeDetails: 'Подробнее',
    descriptionTitle: 'О приложении',
    descriptionMore: 'Ещё...',
    descriptionLess: 'Меньше',
    changesTitle: 'Что нового',
    chartsTitle: 'Оценки и отзывы',
    ratingsDescription:
      'Оценки и отзывы проверены и получены от пользователей, использующих такие же устройства, как у вас',
    ratingLikes: 'пользователей сочли это полезным',
    ratingQuestion: 'Этот отзыв был полезен?',
    ratingQuestionYes: 'Да',
    ratingQuestionNo: 'Нет',
    ratingAllReviews: 'Смотреть все отзывы',
    chartsTotal: 'Всего',
    additionalTitle: 'Дополнительная информация',
    additionalUpdatedTitle: 'Обновлено',
    additionalSizeTitle: 'Размер',
    additionalInstallTitle: 'Установки',
    additionalVersionTitle: 'Текущая версия',
    additionalAgeTitle: 'Возраст',
    additionalDeveloperTitle: 'Разработчик',
    detailsSupport: 'Поддержка приложения',
    detailsPrivacyPolicy: 'Политика конфиденциальности',
    googlePlayRefund: 'Политика возврата Google Play',
    googlePlayVAT: 'Все цены включают НДС.',
    googlePlayGames: 'Игры',
    googlePlayApps: 'Приложения',
    googlePlaySearch: 'Поиск',
    googlePlayBooks: 'Книги',
  },
  ja: {
    appAvailability: 'このアプリはすべてのデバイスで利用できます',
    addToWishlist: 'ウィッシュリストに追加',
    infoChoice: '編集者のおすすめ',
    infoWishList: 'ウィッシュリストに追加',
    infoAge: '年齢',
    infoRatedFor: '対象',
    infoReviews: 'レビュー',
    infoOpen: '開く',
    infoLoading: '読み込み中...',
    infoDownloads: 'ダウンロード数',
    infoInstall: 'インストール',
    infoDownload: 'ダウンロード',
    infoEditorsChoice: '編集者のセレクション',
    infoAboutGame: 'このゲームについて',
    infoDataSafety: 'データの安全性',
    infoDataSafetyDescription:
      'セキュリティは、開発者がどのようにデータを収集・共有するかを理解することから始まります。データのプライバシーとセキュリティの実践は、利用状況、地域、年齢によって異なる場合があります。開発者はこの情報を提供しており、時間とともに更新される可能性があります。',
    infoDataSharing: 'データは第三者と共有されません',
    infoDataSharingLearnMore1: '詳細',
    infoDataSharingLearnMore2: '開発者が共有をどのように宣言するかについて',
    infoDataCollecting: 'データは収集されません',
    infoDataCollectingLearnMore1: '詳細',
    infoDataCollectingLearnMore2: '開発者が収集をどのように宣言するかについて',
    infoSeeDetails: '詳細を見る',
    descriptionTitle: 'アプリについて',
    descriptionMore: 'もっと見る...',
    descriptionLess: '閉じる',
    changesTitle: '新着情報',
    chartsTitle: '評価とレビュー',
    ratingsDescription: '評価とレビューは確認済みで、あなたと同じ種類のデバイスを使用している人々からのものです',
    ratingLikes: '人が役に立ったと評価しました',
    ratingQuestion: 'このレビューは役に立ちましたか？',
    ratingQuestionYes: 'はい',
    ratingQuestionNo: 'いいえ',
    ratingAllReviews: 'すべてのレビューを見る',
    chartsTotal: '合計',
    additionalTitle: '追加情報',
    additionalUpdatedTitle: '更新日',
    additionalSizeTitle: 'サイズ',
    additionalInstallTitle: 'インストール数',
    additionalVersionTitle: '現在のバージョン',
    additionalAgeTitle: '年齢',
    additionalDeveloperTitle: 'デベロッパー',
    detailsSupport: 'アプリサポート',
    detailsPrivacyPolicy: 'プライバシーポリシー',
    googlePlayRefund: 'Google Play 返金ポリシー',
    googlePlayVAT: 'すべての価格には消費税が含まれます。',
    googlePlayGames: 'ゲーム',
    googlePlayApps: 'アプリ',
    googlePlaySearch: '検索',
    googlePlayBooks: '書籍',
  },
  pa: {
    appAvailability: 'ਇਹ ਐਪ ਤੁਹਾਡੇ ਸਾਰੇ ਡਿਵਾਈਸਾਂ ਲਈ ਉਪਲਬਧ ਹੈ',
    addToWishlist: 'ਇੱਛਾ-ਸੂਚੀ ਵਿੱਚ ਸ਼ਾਮਲ ਕਰੋ',
    infoChoice: 'ਸੰਪਾਦਕ ਦੀ ਪਸੰਦ',
    infoWishList: 'ਇੱਛਾ-ਸੂਚੀ ਵਿੱਚ ਸ਼ਾਮਲ ਕਰੋ',
    infoAge: 'ਉਮਰ',
    infoRatedFor: 'ਲਈ ਦਰਜਾ ਦਿੱਤਾ ਗਿਆ',
    infoReviews: 'ਸਮੀਖਿਆਵਾਂ',
    infoOpen: 'ਖੋਲ੍ਹੋ',
    infoLoading: 'ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...',
    infoDownloads: 'ਡਾਊਨਲੋਡ',
    infoInstall: 'ਇੰਸਟਾਲ ਕਰੋ',
    infoDownload: 'ਡਾਊਨਲੋਡ ਕਰੋ',
    infoEditorsChoice: 'ਸੰਪਾਦਕਾਂ ਦੀ ਚੋਣ',
    infoAboutGame: 'ਇਸ ਗੇਮ ਬਾਰੇ',
    infoDataSafety: 'ਡਾਟਾ ਸੁਰੱਖਿਆ',
    infoDataSafetyDescription:
      'ਸੁਰੱਖਿਆ ਇਸ ਗੱਲ ਨੂੰ ਸਮਝਣ ਨਾਲ ਸ਼ੁਰੂ ਹੁੰਦੀ ਹੈ ਕਿ ਡਿਵੈਲਪਰ ਤੁਹਾਡੇ ਡਾਟਾ ਨੂੰ ਕਿਵੇਂ ਇਕੱਠਾ ਕਰਦੇ ਹਨ ਅਤੇ ਸਾਂਝਾ ਕਰਦੇ ਹਨ। ਡਾਟਾ ਗੋਪਨੀਯਤਾ ਅਤੇ ਸੁਰੱਖਿਆ ਅਭਿਆਸ ਤੁਹਾਡੇ ਵਰਤੋਂ, ਖੇਤਰ ਅਤੇ ਉਮਰ ਦੇ ਅਨੁਸਾਰ ਵੱਖਰੇ ਹੋ ਸਕਦੇ ਹਨ। ਡਿਵੈਲਪਰ ਨੇ ਇਹ ਜਾਣਕਾਰੀ ਪ੍ਰਦਾਨ ਕੀਤੀ ਹੈ ਅਤੇ ਸਮੇਂ-ਸਮੇਂ ਤੇ ਇਸ ਨੂੰ ਅਪਡੇਟ ਕਰ ਸਕਦਾ ਹੈ।',
    infoDataSharing: 'ਕੋਈ ਡਾਟਾ ਤੀਜੀਆਂ ਪੱਖਾਂ ਨਾਲ ਸਾਂਝਾ ਨਹੀਂ ਕੀਤਾ ਗਿਆ',
    infoDataSharingLearnMore1: 'ਹੋਰ ਜਾਣੋ',
    infoDataSharingLearnMore2: 'ਡਿਵੈਲਪਰ ਸਾਂਝਾ ਕਰਨ ਦੀ ਘੋਸ਼ਣਾ ਕਿਵੇਂ ਕਰਦੇ ਹਨ',
    infoDataCollecting: 'ਕੋਈ ਡਾਟਾ ਇਕੱਠਾ ਨਹੀਂ ਕੀਤਾ ਗਿਆ',
    infoDataCollectingLearnMore1: 'ਹੋਰ ਜਾਣੋ',
    infoDataCollectingLearnMore2: 'ਡਿਵੈਲਪਰ ਇਕੱਠਾ ਕਰਨ ਦੀ ਘੋਸ਼ਣਾ ਕਿਵੇਂ ਕਰਦੇ ਹਨ',
    infoSeeDetails: 'ਵੇਰਵੇ ਵੇਖੋ',
    descriptionTitle: 'ਐਪ ਬਾਰੇ',
    descriptionMore: 'ਹੋਰ...',
    descriptionLess: 'ਘੱਟ',
    changesTitle: 'ਨਵਾਂ ਕੀ ਹੈ',
    chartsTitle: 'ਰੇਟਿੰਗ ਅਤੇ ਸਮੀਖਿਆਵਾਂ',
    ratingsDescription:
      'ਰੇਟਿੰਗ ਅਤੇ ਸਮੀਖਿਆਵਾਂ ਦੀ ਪੁਸ਼ਟੀ ਕੀਤੀ ਗਈ ਹੈ ਅਤੇ ਉਹ ਲੋਕਾਂ ਤੋਂ ਹਨ ਜੋ ਤੁਹਾਡੇ ਵਰਗੇ ਹੀ ਕਿਸਮ ਦੇ ਡਿਵਾਈਸ ਦੀ ਵਰਤੋਂ ਕਰਦੇ ਹਨ',
    ratingLikes: 'ਲੋਕਾਂ ਨੇ ਇਸਨੂੰ ਲਾਭਦਾਇਕ ਪਾਇਆ',
    ratingQuestion: 'ਕੀ ਇਹ ਸਮੀਖਿਆ ਮਦਦਗਾਰ ਸੀ?',
    ratingQuestionYes: 'ਹਾਂ',
    ratingQuestionNo: 'ਨਹੀਂ',
    ratingAllReviews: 'ਸਭ ਸਮੀਖਿਆਵਾਂ ਵੇਖੋ',
    chartsTotal: 'ਕੁੱਲ',
    additionalTitle: 'ਵਾਧੂ ਜਾਣਕਾਰੀ',
    additionalUpdatedTitle: 'ਅਪਡੇਟ ਕੀਤਾ ਗਿਆ',
    additionalSizeTitle: 'ਆਕਾਰ',
    additionalInstallTitle: 'ਇੰਸਟਾਲੇਸ਼ਨ',
    additionalVersionTitle: 'ਮੌਜੂਦਾ ਵਰਜਨ',
    additionalAgeTitle: 'ਉਮਰ',
    additionalDeveloperTitle: 'ਡਿਵੈਲਪਰ',
    detailsSupport: 'ਐਪ ਸਮਰਥਨ',
    detailsPrivacyPolicy: 'ਗੋਪਨੀਯਤਾ ਨੀਤੀ',
    googlePlayRefund: 'Google Play ਰੀਫੰਡ ਨੀਤੀ',
    googlePlayVAT: 'ਸਾਰੀਆਂ ਕੀਮਤਾਂ ਵਿੱਚ VAT ਸ਼ਾਮਲ ਹੈ।',
    googlePlayGames: 'ਖੇਡਾਂ',
    googlePlayApps: 'ਐਪਸ',
    googlePlaySearch: 'ਖੋਜ',
    googlePlayBooks: 'ਕਿਤਾਬਾਂ',
  },
  de: {
    appAvailability: 'Diese App ist für all Ihre Geräte verfügbar',
    addToWishlist: 'Zur Wunschliste hinzufügen',
    infoChoice: 'Empfehlung der Redaktion',
    infoWishList: 'Zur Wunschliste hinzufügen',
    infoAge: 'Alter',
    infoRatedFor: 'Eingestuft für',
    infoReviews: 'Bewertungen',
    infoOpen: 'Öffnen',
    infoLoading: 'Wird geladen...',
    infoDownloads: 'Downloads',
    infoInstall: 'Installieren',
    infoDownload: 'Herunterladen',
    infoEditorsChoice: 'Auswahl der Redaktion',
    infoAboutGame: 'Über dieses Spiel',
    infoDataSafety: 'Datensicherheit',
    infoDataSafetyDescription:
      'Sicherheit beginnt mit dem Verständnis, wie Entwickler Ihre Daten sammeln und weitergeben. Datenschutz- und Sicherheitspraktiken können je nach Nutzung, Region und Alter variieren. Der Entwickler hat diese Informationen bereitgestellt und kann sie im Laufe der Zeit aktualisieren.',
    infoDataSharing: 'Keine Datenweitergabe an Dritte',
    infoDataSharingLearnMore1: 'Mehr erfahren',
    infoDataSharingLearnMore2: 'darüber, wie Entwickler die Weitergabe erklären',
    infoDataCollecting: 'Keine Daten erhoben',
    infoDataCollectingLearnMore1: 'Mehr erfahren',
    infoDataCollectingLearnMore2: 'darüber, wie Entwickler die Erhebung erklären',
    infoSeeDetails: 'Details ansehen',
    descriptionTitle: 'Über die App',
    descriptionMore: 'Mehr...',
    descriptionLess: 'Weniger',
    changesTitle: 'Neuigkeiten',
    chartsTitle: 'Bewertungen und Rezensionen',
    ratingsDescription:
      'Bewertungen und Rezensionen sind verifiziert und stammen von Personen, die denselben Gerätetyp verwenden wie Sie',
    ratingLikes: 'Personen fanden dies hilfreich',
    ratingQuestion: 'War diese Rezension hilfreich?',
    ratingQuestionYes: 'Ja',
    ratingQuestionNo: 'Nein',
    ratingAllReviews: 'Alle Rezensionen anzeigen',
    chartsTotal: 'Gesamt',
    additionalTitle: 'Zusätzliche Informationen',
    additionalUpdatedTitle: 'Aktualisiert',
    additionalSizeTitle: 'Größe',
    additionalInstallTitle: 'Installationen',
    additionalVersionTitle: 'Aktuelle Version',
    additionalAgeTitle: 'Alter',
    additionalDeveloperTitle: 'Entwickler',
    detailsSupport: 'App-Support',
    detailsPrivacyPolicy: 'Datenschutzerklärung',
    googlePlayRefund: 'Rückerstattungsrichtlinie von Google Play',
    googlePlayVAT: 'Alle Preise inkl. MwSt.',
    googlePlayGames: 'Spiele',
    googlePlayApps: 'Apps',
    googlePlaySearch: 'Suchen',
    googlePlayBooks: 'Bücher',
  },
  jv: {
    appAvailability: 'Aplikasi iki kasedhiya kanggo kabeh piranti sampeyan',
    addToWishlist: 'Tambahna menyang daftar kepinginan',
    infoChoice: 'Pilihan editor',
    infoWishList: 'Tambahna menyang daftar kepinginan',
    infoAge: 'Umur',
    infoRatedFor: 'Dirating kanggo',
    infoReviews: 'ulasan',
    infoOpen: 'Mbukak',
    infoLoading: 'Ngundhuh...',
    infoDownloads: 'Unduhan',
    infoInstall: 'Pasang',
    infoDownload: 'Undhuh',
    infoEditorsChoice: 'Pilihan editor',
    infoAboutGame: 'Babagan game iki',
    infoDataSafety: 'Keamanan data',
    infoDataSafetyDescription:
      'Keamanan diwiwiti saka pangerten babagan carane pangembang nglumpukake lan nuduhake data sampeyan. Praktik privasi lan keamanan bisa beda-beda gumantung panggunaan, wilayah, lan umur sampeyan. Pangembang nyedhiyakake informasi iki lan bisa nganyari kapan wae.',
    infoDataSharing: 'Ora ana data sing dienggo karo pihak katelu',
    infoDataSharingLearnMore1: 'Sinau luwih lengkap',
    infoDataSharingLearnMore2: 'bab carane pangembang ngumumake nuduhake',
    infoDataCollecting: 'Ora ana data sing diklumpukake',
    infoDataCollectingLearnMore1: 'Sinau luwih lengkap',
    infoDataCollectingLearnMore2: 'bab carane pangembang ngumumake nglumpukake',
    infoSeeDetails: 'Deleng rincian',
    descriptionTitle: 'Babagan aplikasi',
    descriptionMore: 'Luwih akeh...',
    descriptionLess: 'Sithik',
    changesTitle: 'Apa sing anyar',
    chartsTitle: 'Rating lan ulasan',
    ratingsDescription: 'Rating lan ulasan wis diverifikasi lan saka wong sing nggunakake piranti padha karo sampeyan',
    ratingLikes: 'wong nemokake iki migunani',
    ratingQuestion: 'Apa ulasan iki migunani?',
    ratingQuestionYes: 'Ya',
    ratingQuestionNo: 'Ora',
    ratingAllReviews: 'Deleng kabeh ulasan',
    chartsTotal: 'Total',
    additionalTitle: 'Informasi tambahan',
    additionalUpdatedTitle: 'Dianyari',
    additionalSizeTitle: 'Ukuran',
    additionalInstallTitle: 'Instalan',
    additionalVersionTitle: 'Versi saiki',
    additionalAgeTitle: 'Umur',
    additionalDeveloperTitle: 'Pangembang',
    detailsSupport: 'Dhukungan aplikasi',
    detailsPrivacyPolicy: 'Kebijakan privasi',
    googlePlayRefund: 'Kabijakan mbalekaken Google Play',
    googlePlayVAT: 'Kabeh rega kalebu PPN.',
    googlePlayGames: 'Game',
    googlePlayApps: 'Aplikasi',
    googlePlaySearch: 'Telusuri',
    googlePlayBooks: 'Buku',
  },
  ko: {
    appAvailability: '이 앱은 모든 기기에서 사용할 수 있습니다',
    addToWishlist: '위시리스트에 추가',
    infoChoice: '에디터 추천',
    infoWishList: '위시리스트에 추가',
    infoAge: '연령',
    infoRatedFor: '대상',
    infoReviews: '리뷰',
    infoOpen: '열기',
    infoLoading: '로드 중...',
    infoDownloads: '다운로드',
    infoInstall: '설치',
    infoDownload: '다운로드',
    infoEditorsChoice: '에디터 선정',
    infoAboutGame: '이 게임에 대하여',
    infoDataSafety: '데이터 보안',
    infoDataSafetyDescription:
      '보안은 개발자가 데이터를 어떻게 수집하고 공유하는지를 이해하는 것에서 시작됩니다. 개인정보 보호 및 보안 방식은 사용, 지역, 연령에 따라 다를 수 있습니다. 개발자가 이 정보를 제공했으며 시간이 지남에 따라 업데이트될 수 있습니다.',
    infoDataSharing: '데이터가 제3자와 공유되지 않습니다',
    infoDataSharingLearnMore1: '자세히 알아보기',
    infoDataSharingLearnMore2: '개발자가 공유를 선언하는 방법에 대해',
    infoDataCollecting: '데이터가 수집되지 않습니다',
    infoDataCollectingLearnMore1: '자세히 알아보기',
    infoDataCollectingLearnMore2: '개발자가 수집을 선언하는 방법에 대해',
    infoSeeDetails: '세부정보 보기',
    descriptionTitle: '앱 정보',
    descriptionMore: '더보기...',
    descriptionLess: '간단히',
    changesTitle: '새로운 소식',
    chartsTitle: '평점 및 리뷰',
    ratingsDescription: '평점과 리뷰는 검증되었으며, 귀하와 동일한 유형의 기기를 사용하는 사람들의 것입니다',
    ratingLikes: '명이 도움이 되었다고 표시했습니다',
    ratingQuestion: '이 리뷰가 도움이 되었습니까?',
    ratingQuestionYes: '예',
    ratingQuestionNo: '아니요',
    ratingAllReviews: '모든 리뷰 보기',
    chartsTotal: '총계',
    additionalTitle: '추가 정보',
    additionalUpdatedTitle: '업데이트됨',
    additionalSizeTitle: '크기',
    additionalInstallTitle: '설치 수',
    additionalVersionTitle: '현재 버전',
    additionalAgeTitle: '연령',
    additionalDeveloperTitle: '개발자',
    detailsSupport: '앱 지원',
    detailsPrivacyPolicy: '개인정보 처리방침',
    googlePlayRefund: 'Google Play 환불 정책',
    googlePlayVAT: '모든 가격에는 부가가치세가 포함됩니다.',
    googlePlayGames: '게임',
    googlePlayApps: '앱',
    googlePlaySearch: '검색',
    googlePlayBooks: '도서',
  },
  fr: {
    appAvailability: 'Cette application est disponible sur tous vos appareils',
    addToWishlist: 'Ajouter à la liste de souhaits',
    infoChoice: 'Choix de la rédaction',
    infoWishList: 'Ajouter à la liste de souhaits',
    infoAge: 'Âge',
    infoRatedFor: 'Classé pour',
    infoReviews: 'avis',
    infoOpen: 'Ouvrir',
    infoLoading: 'Chargement...',
    infoDownloads: 'Téléchargements',
    infoInstall: 'Installer',
    infoDownload: 'Télécharger',
    infoEditorsChoice: 'Sélection des éditeurs',
    infoAboutGame: 'À propos de ce jeu',
    infoDataSafety: 'Sécurité des données',
    infoDataSafetyDescription:
      'La sécurité commence par comprendre comment les développeurs collectent et partagent vos données. Les pratiques de confidentialité et de sécurité peuvent varier en fonction de votre utilisation, de votre région et de votre âge. Le développeur a fourni ces informations et peut les mettre à jour au fil du temps.',
    infoDataSharing: 'Aucune donnée partagée avec des tiers',
    infoDataSharingLearnMore1: 'En savoir plus',
    infoDataSharingLearnMore2: 'sur la façon dont les développeurs déclarent le partage',
    infoDataCollecting: 'Aucune donnée collectée',
    infoDataCollectingLearnMore1: 'En savoir plus',
    infoDataCollectingLearnMore2: 'sur la façon dont les développeurs déclarent la collecte',
    infoSeeDetails: 'Voir les détails',
    descriptionTitle: "À propos de l'application",
    descriptionMore: 'Plus...',
    descriptionLess: 'Moins',
    changesTitle: 'Nouveautés',
    chartsTitle: 'Notes et avis',
    ratingsDescription:
      'Les notes et avis sont vérifiés et proviennent de personnes utilisant le même type d’appareil que vous',
    ratingLikes: 'personnes ont trouvé cela utile',
    ratingQuestion: 'Cet avis vous a-t-il été utile ?',
    ratingQuestionYes: 'Oui',
    ratingQuestionNo: 'Non',
    ratingAllReviews: 'Voir tous les avis',
    chartsTotal: 'Total',
    additionalTitle: 'Informations supplémentaires',
    additionalUpdatedTitle: 'Mis à jour',
    additionalSizeTitle: 'Taille',
    additionalInstallTitle: 'Installations',
    additionalVersionTitle: 'Version actuelle',
    additionalAgeTitle: 'Âge',
    additionalDeveloperTitle: 'Développeur',
    detailsSupport: "Support de l'application",
    detailsPrivacyPolicy: 'Politique de confidentialité',
    googlePlayRefund: 'Politique de remboursement Google Play',
    googlePlayVAT: 'Tous les prix incluent la TVA.',
    googlePlayGames: 'Jeux',
    googlePlayApps: 'Applications',
    googlePlaySearch: 'Rechercher',
    googlePlayBooks: 'Livres',
  },
  te: {
    appAvailability: 'ఈ యాప్ మీ అన్ని పరికరాలకు అందుబాటులో ఉంది',
    addToWishlist: 'విష్‌లిస్ట్‌కి జోడించండి',
    infoChoice: 'ఎడిటర్ ఎంపిక',
    infoWishList: 'విష్‌లిస్ట్‌కి జోడించండి',
    infoAge: 'వయస్సు',
    infoRatedFor: 'కోసం రేటింగ్ ఇవ్వబడింది',
    infoReviews: 'సమీక్షలు',
    infoOpen: 'తెరవండి',
    infoLoading: 'లోడ్ అవుతోంది...',
    infoDownloads: 'డౌన్‌లోడ్లు',
    infoInstall: 'ఇన్‌స్టాల్ చేయండి',
    infoDownload: 'డౌన్‌లోడ్',
    infoEditorsChoice: 'ఎడిటర్ల ఎంపిక',
    infoAboutGame: 'ఈ గేమ్ గురించి',
    infoDataSafety: 'డేటా భద్రత',
    infoDataSafetyDescription:
      'డెవలపర్లు మీ డేటాను ఎలా సేకరించి పంచుకుంటారో అర్థం చేసుకోవడం ద్వారా భద్రత ప్రారంభమవుతుంది. డేటా గోప్యత మరియు భద్రతా ఆచరణలు మీ వినియోగం, ప్రాంతం మరియు వయస్సు ఆధారంగా మారవచ్చు. డెవలపర్ ఈ సమాచారాన్ని అందించాడు మరియు సమయానుకూలంగా దీన్ని నవీకరించవచ్చు.',
    infoDataSharing: 'మూడవ పక్షాలతో డేటా పంచుకోబడదు',
    infoDataSharingLearnMore1: 'ఇంకా తెలుసుకోండి',
    infoDataSharingLearnMore2: 'డెవలపర్లు పంచుకోవడాన్ని ఎలా ప్రకటిస్తారో గురించి',
    infoDataCollecting: 'ఏ డేటా సేకరించబడలేదు',
    infoDataCollectingLearnMore1: 'ఇంకా తెలుసుకోండి',
    infoDataCollectingLearnMore2: 'డెవలపర్లు సేకరణను ఎలా ప్రకటిస్తారో గురించి',
    infoSeeDetails: 'వివరాలు చూడండి',
    descriptionTitle: 'యాప్ గురించి',
    descriptionMore: 'మరిన్ని...',
    descriptionLess: 'తక్కువ',
    changesTitle: 'కొత్తది ఏమిటి',
    chartsTitle: 'రేటింగ్‌లు మరియు సమీక్షలు',
    ratingsDescription:
      'రేటింగ్‌లు మరియు సమీక్షలు ధృవీకరించబడ్డాయి మరియు మీ వంటి పరికరాన్ని ఉపయోగించే వ్యక్తుల నుండి వచ్చాయి',
    ratingLikes: 'మందికి ఇది ఉపయోగకరంగా అనిపించింది',
    ratingQuestion: 'ఈ సమీక్ష ఉపయోగకరమా?',
    ratingQuestionYes: 'అవును',
    ratingQuestionNo: 'కాదు',
    ratingAllReviews: 'అన్ని సమీక్షలు చూడండి',
    chartsTotal: 'మొత్తం',
    additionalTitle: 'అదనపు సమాచారం',
    additionalUpdatedTitle: 'నవీకరించబడింది',
    additionalSizeTitle: 'పరిమాణం',
    additionalInstallTitle: 'ఇన్‌స్టాలేషన్లు',
    additionalVersionTitle: 'ప్రస్తుత వెర్షన్',
    additionalAgeTitle: 'వయస్సు',
    additionalDeveloperTitle: 'డెవలపర్',
    detailsSupport: 'యాప్ సహాయం',
    detailsPrivacyPolicy: 'గోప్యతా విధానం',
    googlePlayRefund: 'Google Play రీఫండ్ విధానం',
    googlePlayVAT: 'అన్ని ధరల్లో GST చేర్చబడి ఉంది.',
    googlePlayGames: 'గేమ్స్',
    googlePlayApps: 'యాప్‌లు',
    googlePlaySearch: 'శోధన',
    googlePlayBooks: 'పుస్తకాలు',
  },
  mr: {
    appAvailability: 'हे अॅप तुमच्या सर्व उपकरणांवर उपलब्ध आहे',
    addToWishlist: 'इच्छा-सूचीत जोडा',
    infoChoice: 'संपादकांची निवड',
    infoWishList: 'इच्छा-सूचीत जोडा',
    infoAge: 'वय',
    infoRatedFor: 'साठी रेट केलेले',
    infoReviews: 'पुनरावलोकने',
    infoOpen: 'उघडा',
    infoLoading: 'लोड होत आहे...',
    infoDownloads: 'डाउनलोड्स',
    infoInstall: 'इंस्टॉल करा',
    infoDownload: 'डाउनलोड',
    infoEditorsChoice: 'संपादकांची निवड',
    infoAboutGame: 'या गेमबद्दल',
    infoDataSafety: 'डेटा सुरक्षितता',
    infoDataSafetyDescription:
      'सुरक्षितता समजून घेण्यापासून सुरू होते की विकसक तुमचा डेटा कसा गोळा आणि शेअर करतात. डेटा गोपनीयता आणि सुरक्षिततेच्या पद्धती तुमच्या वापर, प्रदेश आणि वयानुसार बदलू शकतात. विकसकाने ही माहिती दिली आहे आणि वेळोवेळी अद्यतनित करू शकतो.',
    infoDataSharing: 'डेटा तृतीय पक्षांसोबत शेअर केला जात नाही',
    infoDataSharingLearnMore1: 'अधिक जाणून घ्या',
    infoDataSharingLearnMore2: 'विकसक शेअरिंग कसे जाहीर करतात याबद्दल',
    infoDataCollecting: 'कोणताही डेटा गोळा केलेला नाही',
    infoDataCollectingLearnMore1: 'अधिक जाणून घ्या',
    infoDataCollectingLearnMore2: 'विकसक संकलन कसे जाहीर करतात याबद्दल',
    infoSeeDetails: 'तपशील पहा',
    descriptionTitle: 'अॅपबद्दल',
    descriptionMore: 'अधिक...',
    descriptionLess: 'कमी',
    changesTitle: 'नवीन काय आहे',
    chartsTitle: 'रेटिंग आणि पुनरावलोकने',
    ratingsDescription: 'रेटिंग आणि पुनरावलोकने सत्यापित आहेत आणि तुमच्यासारखेच उपकरण वापरणाऱ्या लोकांकडून आहेत',
    ratingLikes: 'लोकांना हे उपयुक्त वाटले',
    ratingQuestion: 'हे पुनरावलोकन उपयुक्त होते का?',
    ratingQuestionYes: 'होय',
    ratingQuestionNo: 'नाही',
    ratingAllReviews: 'सर्व पुनरावलोकने पहा',
    chartsTotal: 'एकूण',
    additionalTitle: 'अतिरिक्त माहिती',
    additionalUpdatedTitle: 'अद्यतनित',
    additionalSizeTitle: 'आकार',
    additionalInstallTitle: 'इंस्टॉलेशन्स',
    additionalVersionTitle: 'सध्याचा आवृत्ती',
    additionalAgeTitle: 'वय',
    additionalDeveloperTitle: 'विकसक',
    detailsSupport: 'अॅप समर्थन',
    detailsPrivacyPolicy: 'गोपनीयता धोरण',
    googlePlayRefund: 'Google Play परतावा धोरण',
    googlePlayVAT: 'सर्व किंमतींमध्ये जीएसटी समाविष्ट आहे.',
    googlePlayGames: 'गेम्स',
    googlePlayApps: 'अॅप्स',
    googlePlaySearch: 'शोधा',
    googlePlayBooks: 'पुस्तके',
  },
  tr: {
    appAvailability: 'Bu uygulama tüm cihazlarınızda kullanılabilir',
    addToWishlist: 'İstek listesine ekle',
    infoChoice: 'Editörün seçimi',
    infoWishList: 'İstek listesine ekle',
    infoAge: 'Yaş',
    infoRatedFor: 'İçin derecelendirildi',
    infoReviews: 'yorum',
    infoOpen: 'Aç',
    infoLoading: 'Yükleniyor...',
    infoDownloads: 'İndirmeler',
    infoInstall: 'Yükle',
    infoDownload: 'İndir',
    infoEditorsChoice: 'Editörün seçtikleri',
    infoAboutGame: 'Bu oyun hakkında',
    infoDataSafety: 'Veri güvenliği',
    infoDataSafetyDescription:
      'Güvenlik, geliştiricilerin verilerinizi nasıl topladığını ve paylaştığını anlamakla başlar. Veri gizliliği ve güvenlik uygulamaları kullanımınıza, bölgenize ve yaşınıza göre değişebilir. Geliştirici bu bilgiyi sağladı ve zamanla güncelleyebilir.',
    infoDataSharing: 'Veriler üçüncü taraflarla paylaşılmaz',
    infoDataSharingLearnMore1: 'Daha fazla bilgi edinin',
    infoDataSharingLearnMore2: 'Geliştiricilerin paylaşımı nasıl açıkladıkları hakkında',
    infoDataCollecting: 'Hiçbir veri toplanmaz',
    infoDataCollectingLearnMore1: 'Daha fazla bilgi edinin',
    infoDataCollectingLearnMore2: 'Geliştiricilerin toplama işlemini nasıl açıkladıkları hakkında',
    infoSeeDetails: 'Ayrıntıları gör',
    descriptionTitle: 'Uygulama hakkında',
    descriptionMore: 'Daha fazla...',
    descriptionLess: 'Daha az',
    changesTitle: 'Yenilikler',
    chartsTitle: 'Derecelendirmeler ve incelemeler',
    ratingsDescription:
      'Derecelendirmeler ve incelemeler doğrulanmıştır ve sizinle aynı tür cihazı kullanan kişilerden gelir',
    ratingLikes: 'kişi bunu faydalı buldu',
    ratingQuestion: 'Bu inceleme faydalı mıydı?',
    ratingQuestionYes: 'Evet',
    ratingQuestionNo: 'Hayır',
    ratingAllReviews: 'Tüm incelemeleri gör',
    chartsTotal: 'Toplam',
    additionalTitle: 'Ek bilgiler',
    additionalUpdatedTitle: 'Güncellendi',
    additionalSizeTitle: 'Boyut',
    additionalInstallTitle: 'Kurulumlar',
    additionalVersionTitle: 'Geçerli sürüm',
    additionalAgeTitle: 'Yaş',
    additionalDeveloperTitle: 'Geliştirici',
    detailsSupport: 'Uygulama desteği',
    detailsPrivacyPolicy: 'Gizlilik politikası',
    googlePlayRefund: 'Google Play iade politikası',
    googlePlayVAT: 'Tüm fiyatlara KDV dahildir.',
    googlePlayGames: 'Oyunlar',
    googlePlayApps: 'Uygulamalar',
    googlePlaySearch: 'Ara',
    googlePlayBooks: 'Kitaplar',
  },
  ta: {
    appAvailability: 'இந்த பயன்பாடு உங்கள் அனைத்து சாதனங்களிலும் கிடைக்கும்',
    addToWishlist: 'விருப்பப்பட்டியலில் சேர்',
    infoChoice: 'தொகுப்பாளர் தேர்வு',
    infoWishList: 'விருப்பப்பட்டியலில் சேர்',
    infoAge: 'வயது',
    infoRatedFor: 'க்கு மதிப்பிடப்பட்டது',
    infoReviews: 'விமர்சனங்கள்',
    infoOpen: 'திறக்க',
    infoLoading: 'ஏற்றப்படுகிறது...',
    infoDownloads: 'பதிவிறக்கங்கள்',
    infoInstall: 'நிறுவவும்',
    infoDownload: 'பதிவிறக்கவும்',
    infoEditorsChoice: 'தொகுப்பாளரின் தேர்வுகள்',
    infoAboutGame: 'இந்த விளையாட்டைப் பற்றி',
    infoDataSafety: 'தரவு பாதுகாப்பு',
    infoDataSafetyDescription:
      'உங்கள் தரவை டெவலப்பர்கள் எவ்வாறு சேகரித்து பகிர்கிறார்கள் என்பதைப் புரிந்துகொள்வதிலிருந்து பாதுகாப்பு தொடங்குகிறது. தரவு தனியுரிமை மற்றும் பாதுகாப்பு நடைமுறைகள் உங்கள் பயன்பாடு, பகுதி மற்றும் வயதைப் பொறுத்து மாறுபடலாம். டெவலப்பர் இந்தத் தகவலை வழங்கியுள்ளார் மற்றும் காலத்திற்கேற்ப புதுப்பிக்கலாம்.',
    infoDataSharing: 'மூன்றாம் தரப்பினருடன் எந்த தரவும் பகிரப்படவில்லை',
    infoDataSharingLearnMore1: 'மேலும் அறிக',
    infoDataSharingLearnMore2: 'டெவலப்பர்கள் பகிர்வை எவ்வாறு அறிவிக்கிறார்கள் என்பதைப் பற்றி',
    infoDataCollecting: 'தரவு எதுவும் சேகரிக்கப்படவில்லை',
    infoDataCollectingLearnMore1: 'மேலும் அறிக',
    infoDataCollectingLearnMore2: 'டெவலப்பர்கள் சேகரிப்பை எவ்வாறு அறிவிக்கிறார்கள் என்பதைப் பற்றி',
    infoSeeDetails: 'விவரங்களைப் பார்க்க',
    descriptionTitle: 'பயன்பாட்டைப் பற்றி',
    descriptionMore: 'மேலும்...',
    descriptionLess: 'குறைவு',
    changesTitle: 'புதியது என்ன',
    chartsTitle: 'மதிப்பீடுகள் மற்றும் விமர்சனங்கள்',
    ratingsDescription:
      'மதிப்பீடுகள் மற்றும் விமர்சனங்கள் சரிபார்க்கப்பட்டவை மற்றும் உங்களின் சாதனத்தைப் போன்ற சாதனத்தைப் பயன்படுத்தும் நபர்களிடமிருந்து வருகின்றன',
    ratingLikes: 'மக்களுக்கு இது பயனுள்ளதாக இருந்தது',
    ratingQuestion: 'இந்த விமர்சனம் பயனுள்ளதாக இருந்ததா?',
    ratingQuestionYes: 'ஆம்',
    ratingQuestionNo: 'இல்லை',
    ratingAllReviews: 'அனைத்து விமர்சனங்களையும் பார்க்க',
    chartsTotal: 'மொத்தம்',
    additionalTitle: 'கூடுதல் தகவல்',
    additionalUpdatedTitle: 'புதுப்பிக்கப்பட்டது',
    additionalSizeTitle: 'அளவு',
    additionalInstallTitle: 'நிறுவல்கள்',
    additionalVersionTitle: 'தற்போதைய பதிப்பு',
    additionalAgeTitle: 'வயது',
    additionalDeveloperTitle: 'டெவலப்பர்',
    detailsSupport: 'பயன்பாட்டு ஆதரவு',
    detailsPrivacyPolicy: 'தனியுரிமைக் கொள்கை',
    googlePlayRefund: 'Google Play பணத்தைத் திரும்பப்பெறும் கொள்கை',
    googlePlayVAT: 'அனைத்து விலைகளிலும் வரி அடங்கும்.',
    googlePlayGames: 'விளையாட்டுகள்',
    googlePlayApps: 'பயன்பாடுகள்',
    googlePlaySearch: 'தேடு',
    googlePlayBooks: 'புத்தகங்கள்',
  },
  vi: {
    appAvailability: 'Ứng dụng này có sẵn cho tất cả thiết bị của bạn',
    addToWishlist: 'Thêm vào danh sách mong muốn',
    infoChoice: 'Lựa chọn của biên tập viên',
    infoWishList: 'Thêm vào danh sách mong muốn',
    infoAge: 'Độ tuổi',
    infoRatedFor: 'Được xếp hạng cho',
    infoReviews: 'đánh giá',
    infoOpen: 'Mở',
    infoLoading: 'Đang tải...',
    infoDownloads: 'Lượt tải xuống',
    infoInstall: 'Cài đặt',
    infoDownload: 'Tải xuống',
    infoEditorsChoice: 'Biên tập viên chọn',
    infoAboutGame: 'Về trò chơi này',
    infoDataSafety: 'An toàn dữ liệu',
    infoDataSafetyDescription:
      'Bảo mật bắt đầu bằng việc hiểu cách nhà phát triển thu thập và chia sẻ dữ liệu của bạn. Các thực tiễn về quyền riêng tư và bảo mật có thể khác nhau tùy theo cách sử dụng, khu vực và độ tuổi. Nhà phát triển đã cung cấp thông tin này và có thể cập nhật theo thời gian.',
    infoDataSharing: 'Không chia sẻ dữ liệu với bên thứ ba',
    infoDataSharingLearnMore1: 'Tìm hiểu thêm',
    infoDataSharingLearnMore2: 'về cách nhà phát triển tuyên bố chia sẻ',
    infoDataCollecting: 'Không thu thập dữ liệu',
    infoDataCollectingLearnMore1: 'Tìm hiểu thêm',
    infoDataCollectingLearnMore2: 'về cách nhà phát triển tuyên bố thu thập',
    infoSeeDetails: 'Xem chi tiết',
    descriptionTitle: 'Về ứng dụng',
    descriptionMore: 'Thêm...',
    descriptionLess: 'Ít hơn',
    changesTitle: 'Có gì mới',
    chartsTitle: 'Xếp hạng và đánh giá',
    ratingsDescription:
      'Xếp hạng và đánh giá đã được xác minh và đến từ những người sử dụng cùng loại thiết bị như bạn',
    ratingLikes: 'người thấy hữu ích',
    ratingQuestion: 'Đánh giá này có hữu ích không?',
    ratingQuestionYes: 'Có',
    ratingQuestionNo: 'Không',
    ratingAllReviews: 'Xem tất cả đánh giá',
    chartsTotal: 'Tổng cộng',
    additionalTitle: 'Thông tin bổ sung',
    additionalUpdatedTitle: 'Đã cập nhật',
    additionalSizeTitle: 'Kích thước',
    additionalInstallTitle: 'Lượt cài đặt',
    additionalVersionTitle: 'Phiên bản hiện tại',
    additionalAgeTitle: 'Độ tuổi',
    additionalDeveloperTitle: 'Nhà phát triển',
    detailsSupport: 'Hỗ trợ ứng dụng',
    detailsPrivacyPolicy: 'Chính sách bảo mật',
    googlePlayRefund: 'Chính sách hoàn tiền của Google Play',
    googlePlayVAT: 'Tất cả giá đã bao gồm VAT.',
    googlePlayGames: 'Trò chơi',
    googlePlayApps: 'Ứng dụng',
    googlePlaySearch: 'Tìm kiếm',
    googlePlayBooks: 'Sách',
  },
  ur: {
    appAvailability: 'یہ ایپ آپ کے تمام آلات کے لیے دستیاب ہے',
    addToWishlist: 'خواہشات کی فہرست میں شامل کریں',
    infoChoice: 'مدیر کا انتخاب',
    infoWishList: 'خواہشات کی فہرست میں شامل کریں',
    infoAge: 'عمر',
    infoRatedFor: 'کے لیے درجہ بند',
    infoReviews: 'جائزے',
    infoOpen: 'کھولیں',
    infoLoading: 'لوڈ ہو رہا ہے...',
    infoDownloads: 'ڈاؤن لوڈز',
    infoInstall: 'انسٹال کریں',
    infoDownload: 'ڈاؤن لوڈ کریں',
    infoEditorsChoice: 'مدیروں کا انتخاب',
    infoAboutGame: 'اس کھیل کے بارے میں',
    infoDataSafety: 'ڈیٹا کی حفاظت',
    infoDataSafetyDescription:
      'حفاظت اس بات کو سمجھنے سے شروع ہوتی ہے کہ ڈویلپر آپ کا ڈیٹا کیسے جمع اور شیئر کرتے ہیں۔ رازداری اور حفاظت کے طریقے آپ کے استعمال، علاقے اور عمر کے لحاظ سے مختلف ہو سکتے ہیں۔ ڈویلپر نے یہ معلومات فراہم کی ہیں اور وقتاً فوقتاً اسے اپ ڈیٹ کر سکتا ہے۔',
    infoDataSharing: 'ڈیٹا کسی تیسرے فریق کے ساتھ شیئر نہیں کیا جاتا',
    infoDataSharingLearnMore1: 'مزید جانیں',
    infoDataSharingLearnMore2: 'کہ ڈویلپر شیئرنگ کا اعلان کیسے کرتے ہیں',
    infoDataCollecting: 'کوئی ڈیٹا جمع نہیں کیا گیا',
    infoDataCollectingLearnMore1: 'مزید جانیں',
    infoDataCollectingLearnMore2: 'کہ ڈویلپر جمع کرنے کا اعلان کیسے کرتے ہیں',
    infoSeeDetails: 'تفصیلات دیکھیں',
    descriptionTitle: 'ایپ کے بارے میں',
    descriptionMore: 'مزید...',
    descriptionLess: 'کم',
    changesTitle: 'نیا کیا ہے',
    chartsTitle: 'درجہ بندیاں اور جائزے',
    ratingsDescription:
      'درجہ بندیاں اور جائزے تصدیق شدہ ہیں اور ان لوگوں سے ہیں جو آپ کے جیسے ہی قسم کے آلے استعمال کرتے ہیں',
    ratingLikes: 'لوگوں نے اسے مددگار پایا',
    ratingQuestion: 'کیا یہ جائزہ مددگار تھا؟',
    ratingQuestionYes: 'جی ہاں',
    ratingQuestionNo: 'نہیں',
    ratingAllReviews: 'تمام جائزے دیکھیں',
    chartsTotal: 'کل',
    additionalTitle: 'اضافی معلومات',
    additionalUpdatedTitle: 'اپ ڈیٹ کیا گیا',
    additionalSizeTitle: 'سائز',
    additionalInstallTitle: 'انسٹالیشنز',
    additionalVersionTitle: 'موجودہ ورژن',
    additionalAgeTitle: 'عمر',
    additionalDeveloperTitle: 'ڈویلپر',
    detailsSupport: 'ایپ سپورٹ',
    detailsPrivacyPolicy: 'رازداری کی پالیسی',
    googlePlayRefund: 'Google Play رقم واپسی کی پالیسی',
    googlePlayVAT: 'تمام قیمتوں میں VAT شامل ہے۔',
    googlePlayGames: 'کھیل',
    googlePlayApps: 'ایپس',
    googlePlaySearch: 'تلاش کریں',
    googlePlayBooks: 'کتابیں',
  },
  th: {
    appAvailability: 'แอปนี้ใช้ได้บนอุปกรณ์ทั้งหมดของคุณ',
    addToWishlist: 'เพิ่มในรายการสิ่งที่อยากได้',
    infoChoice: 'ตัวเลือกของบรรณาธิการ',
    infoWishList: 'เพิ่มในรายการสิ่งที่อยากได้',
    infoAge: 'อายุ',
    infoRatedFor: 'จัดอันดับสำหรับ',
    infoReviews: 'รีวิว',
    infoOpen: 'เปิด',
    infoLoading: 'กำลังโหลด...',
    infoDownloads: 'จำนวนดาวน์โหลด',
    infoInstall: 'ติดตั้ง',
    infoDownload: 'ดาวน์โหลด',
    infoEditorsChoice: 'คัดสรรโดยบรรณาธิการ',
    infoAboutGame: 'เกี่ยวกับเกมนี้',
    infoDataSafety: 'ความปลอดภัยของข้อมูล',
    infoDataSafetyDescription:
      'ความปลอดภัยเริ่มต้นจากการทำความเข้าใจว่า นักพัฒนารวบรวมและแบ่งปันข้อมูลของคุณอย่างไร แนวทางด้านความเป็นส่วนตัวและความปลอดภัยอาจแตกต่างกันไปตามการใช้งาน ภูมิภาค และอายุ นักพัฒนาจัดทำข้อมูลนี้และอาจมีการอัปเดตเป็นระยะ',
    infoDataSharing: 'ไม่มีการแบ่งปันข้อมูลกับบุคคลที่สาม',
    infoDataSharingLearnMore1: 'เรียนรู้เพิ่มเติม',
    infoDataSharingLearnMore2: 'เกี่ยวกับวิธีที่นักพัฒนาประกาศการแบ่งปันข้อมูล',
    infoDataCollecting: 'ไม่มีการรวบรวมข้อมูล',
    infoDataCollectingLearnMore1: 'เรียนรู้เพิ่มเติม',
    infoDataCollectingLearnMore2: 'เกี่ยวกับวิธีที่นักพัฒนาประกาศการเก็บข้อมูล',
    infoSeeDetails: 'ดูรายละเอียด',
    descriptionTitle: 'เกี่ยวกับแอป',
    descriptionMore: 'เพิ่มเติม...',
    descriptionLess: 'ย่อลง',
    changesTitle: 'มีอะไรใหม่',
    chartsTitle: 'การให้คะแนนและรีวิว',
    ratingsDescription: 'การให้คะแนนและรีวิวได้รับการยืนยันแล้ว และมาจากผู้ที่ใช้อุปกรณ์ประเภทเดียวกับคุณ',
    ratingLikes: 'คนพบว่ามีประโยชน์',
    ratingQuestion: 'รีวิวนี้มีประโยชน์หรือไม่?',
    ratingQuestionYes: 'ใช่',
    ratingQuestionNo: 'ไม่',
    ratingAllReviews: 'ดูรีวิวทั้งหมด',
    chartsTotal: 'ทั้งหมด',
    additionalTitle: 'ข้อมูลเพิ่มเติม',
    additionalUpdatedTitle: 'อัปเดต',
    additionalSizeTitle: 'ขนาด',
    additionalInstallTitle: 'จำนวนการติดตั้ง',
    additionalVersionTitle: 'เวอร์ชันปัจจุบัน',
    additionalAgeTitle: 'อายุ',
    additionalDeveloperTitle: 'นักพัฒนา',
    detailsSupport: 'การสนับสนุนแอป',
    detailsPrivacyPolicy: 'นโยบายความเป็นส่วนตัว',
    googlePlayRefund: 'นโยบายการคืนเงินของ Google Play',
    googlePlayVAT: 'ราคาทั้งหมดรวมภาษีมูลค่าเพิ่มแล้ว',
    googlePlayGames: 'เกม',
    googlePlayApps: 'แอป',
    googlePlaySearch: 'ค้นหา',
    googlePlayBooks: 'หนังสือ',
  },
  gu: {
    appAvailability: 'આ એપ તમારી બધી ડિવાઇસ માટે ઉપલબ્ધ છે',
    addToWishlist: 'ઇચ્છાસૂચિમાં ઉમેરો',
    infoChoice: 'સંપાદકની પસંદગી',
    infoWishList: 'ઇચ્છાસૂચિમાં ઉમેરો',
    infoAge: 'ઉંમર',
    infoRatedFor: 'માટે રેટેડ',
    infoReviews: 'સમીક્ષાઓ',
    infoOpen: 'ખોલો',
    infoLoading: 'લોડ થઈ રહ્યું છે...',
    infoDownloads: 'ડાઉનલોડ્સ',
    infoInstall: 'ઇન્સ્ટોલ કરો',
    infoDownload: 'ડાઉનલોડ',
    infoEditorsChoice: 'સંપાદકોની પસંદગી',
    infoAboutGame: 'આ રમતમાં વિશે',
    infoDataSafety: 'ડેટા સુરક્ષા',
    infoDataSafetyDescription:
      'સુરક્ષા એ સમજવાથી શરૂ થાય છે કે ડેવલપર તમારા ડેટાને કેવી રીતે એકત્ર અને શેર કરે છે. ગોપનીયતા અને સુરક્ષા પદ્ધતિઓ તમારા ઉપયોગ, પ્રદેશ અને ઉંમર પ્રમાણે બદલાઈ શકે. ડેવલપરે આ માહિતી આપી છે અને તે સમયાંતરે અપડેટ કરી શકે છે.',
    infoDataSharing: 'ડેટા તૃતીય પક્ષો સાથે શેર કરવામાં આવતા નથી',
    infoDataSharingLearnMore1: 'વધુ જાણો',
    infoDataSharingLearnMore2: 'ડેવલપરો શેરિંગ કેવી રીતે જાહેર કરે છે તે વિશે',
    infoDataCollecting: 'કોઈ ડેટા એકત્રિત કરવામાં આવ્યો નથી',
    infoDataCollectingLearnMore1: 'વધુ જાણો',
    infoDataCollectingLearnMore2: 'ડેવલપરો સંગ્રહ કેવી રીતે જાહેર કરે છે તે વિશે',
    infoSeeDetails: 'વિગતો જુઓ',
    descriptionTitle: 'એપ વિશે',
    descriptionMore: 'વધારે...',
    descriptionLess: 'ઓછું',
    changesTitle: 'નવું શું છે',
    chartsTitle: 'રેટિંગ્સ અને સમીક્ષાઓ',
    ratingsDescription: 'રેટિંગ્સ અને સમીક્ષાઓ ચકાસેલ છે અને તમારા જેવા જ પ્રકારની ડિવાઇસ વાપરતા લોકો પાસેથી છે',
    ratingLikes: 'લોકોને આ ઉપયોગી લાગ્યું',
    ratingQuestion: 'શું આ સમીક્ષા ઉપયોગી હતી?',
    ratingQuestionYes: 'હા',
    ratingQuestionNo: 'ના',
    ratingAllReviews: 'બધી સમીક્ષાઓ જુઓ',
    chartsTotal: 'કુલ',
    additionalTitle: 'વધારાની માહિતી',
    additionalUpdatedTitle: 'અપડેટ થયું',
    additionalSizeTitle: 'કદ',
    additionalInstallTitle: 'ઇન્સ્ટોલેશન્સ',
    additionalVersionTitle: 'વર્તમાન આવૃત્તિ',
    additionalAgeTitle: 'ઉંમર',
    additionalDeveloperTitle: 'ડેવલપર',
    detailsSupport: 'એપ સપોર્ટ',
    detailsPrivacyPolicy: 'ગોપનીયતા નીતિ',
    googlePlayRefund: 'Google Play રિફંડ નીતિ',
    googlePlayVAT: 'બધી કિંમતોમાં GST સામેલ છે.',
    googlePlayGames: 'ગેમ્સ',
    googlePlayApps: 'એપ્સ',
    googlePlaySearch: 'શોધો',
    googlePlayBooks: 'પુસ્તકો',
  },
  pl: {
    appAvailability: 'Ta aplikacja jest dostępna na wszystkich Twoich urządzeniach',
    addToWishlist: 'Dodaj do listy życzeń',
    infoChoice: 'Wybór redakcji',
    infoWishList: 'Dodaj do listy życzeń',
    infoAge: 'Wiek',
    infoRatedFor: 'Przeznaczenie',
    infoReviews: 'opinie',
    infoOpen: 'Otwórz',
    infoLoading: 'Ładowanie...',
    infoDownloads: 'Pobrania',
    infoInstall: 'Zainstaluj',
    infoDownload: 'Pobierz',
    infoEditorsChoice: 'Wybór redaktorów',
    infoAboutGame: 'O tej grze',
    infoDataSafety: 'Bezpieczeństwo danych',
    infoDataSafetyDescription:
      'Bezpieczeństwo zaczyna się od zrozumienia, w jaki sposób deweloperzy zbierają i udostępniają Twoje dane. Praktyki dotyczące prywatności i bezpieczeństwa mogą się różnić w zależności od sposobu użycia, regionu i wieku. Deweloper dostarczył te informacje i może je z czasem aktualizować.',
    infoDataSharing: 'Brak udostępniania danych stronom trzecim',
    infoDataSharingLearnMore1: 'Dowiedz się więcej',
    infoDataSharingLearnMore2: 'o tym, jak deweloperzy deklarują udostępnianie',
    infoDataCollecting: 'Brak gromadzenia danych',
    infoDataCollectingLearnMore1: 'Dowiedz się więcej',
    infoDataCollectingLearnMore2: 'o tym, jak deweloperzy deklarują gromadzenie',
    infoSeeDetails: 'Zobacz szczegóły',
    descriptionTitle: 'O aplikacji',
    descriptionMore: 'Więcej...',
    descriptionLess: 'Mniej',
    changesTitle: 'Co nowego',
    chartsTitle: 'Oceny i recenzje',
    ratingsDescription:
      'Oceny i recenzje są zweryfikowane i pochodzą od osób używających tego samego typu urządzenia co Ty',
    ratingLikes: 'osób uznało to za pomocne',
    ratingQuestion: 'Czy ta recenzja była pomocna?',
    ratingQuestionYes: 'Tak',
    ratingQuestionNo: 'Nie',
    ratingAllReviews: 'Zobacz wszystkie recenzje',
    chartsTotal: 'Razem',
    additionalTitle: 'Dodatkowe informacje',
    additionalUpdatedTitle: 'Zaktualizowano',
    additionalSizeTitle: 'Rozmiar',
    additionalInstallTitle: 'Instalacje',
    additionalVersionTitle: 'Aktualna wersja',
    additionalAgeTitle: 'Wiek',
    additionalDeveloperTitle: 'Deweloper',
    detailsSupport: 'Wsparcie aplikacji',
    detailsPrivacyPolicy: 'Polityka prywatności',
    googlePlayRefund: 'Polityka zwrotów Google Play',
    googlePlayVAT: 'Wszystkie ceny zawierają VAT.',
    googlePlayGames: 'Gry',
    googlePlayApps: 'Aplikacje',
    googlePlaySearch: 'Szukaj',
    googlePlayBooks: 'Książki',
  },
  ml: {
    appAvailability: 'ഈ ആപ്പ് നിങ്ങളുടെ എല്ലാ ഉപകരണങ്ങൾക്കും ലഭ്യമാണ്',
    addToWishlist: 'വിഷ്‌ലിസ്റ്റിൽ ചേർക്കുക',
    infoChoice: 'എഡിറ്റർസ് ചോയ്സ്',
    infoWishList: 'വിഷ്‌ലിസ്റ്റിൽ ചേർക്കുക',
    infoAge: 'പ്രായം',
    infoRatedFor: 'ഇതിനായി റേറ്റുചെയ്തത്',
    infoReviews: 'അവലോകനങ്ങൾ',
    infoOpen: 'തുറക്കുക',
    infoLoading: 'ലോഡ് ചെയ്യുന്നു...',
    infoDownloads: 'ഡൗൺലോഡുകൾ',
    infoInstall: 'ഇൻസ്റ്റാൾ ചെയ്യുക',
    infoDownload: 'ഡൗൺലോഡ്',
    infoEditorsChoice: 'എഡിറ്റർമാരുടെ തെരഞ്ഞടുപ്പ്',
    infoAboutGame: 'ഈ ഗെയിംയെ കുറിച്ച്',
    infoDataSafety: 'ഡാറ്റാ സുരക്ഷ',
    infoDataSafetyDescription:
      'ഡെവലപ്പർമാർ നിങ്ങളുടെ ഡാറ്റ എങ്ങനെ ശേഖരിക്കുകയും പങ്കിടുകയും ചെയ്യുന്നു എന്ന് മനസ്സിലാക്കുന്നതോടെയാണ് സുരക്ഷ ആരംഭിക്കുന്നത്. സ്വകാര്യതയും സുരക്ഷയും സംബന്ധിച്ച രീതികൾ നിങ്ങളുടെ ഉപയോഗം, പ്രദേശം, പ്രായം എന്നിവയെ ആശ്രയിച്ച് വ്യത്യാസപ്പെട്ടേക്കാം. ഡെവലപ്പർ ഈ വിവരം നൽകിയിട്ടുണ്ട്; ഇത് സമയം സമയം അപ്‌ഡേറ്റ് ചെയ്യാം.',
    infoDataSharing: 'ഡാറ്റ മൂന്നാം കക്ഷികളുമായി പങ്കിടുന്നില്ല',
    infoDataSharingLearnMore1: 'കൂടുതൽ അറിയുക',
    infoDataSharingLearnMore2: 'ഡെവലപ്പർമാർ പങ്കിടൽ എങ്ങനെ പ്രഖ്യാപിക്കുന്നു എന്ന്',
    infoDataCollecting: 'ഡാറ്റ ശേഖരണം ഇല്ല',
    infoDataCollectingLearnMore1: 'കൂടുതൽ അറിയുക',
    infoDataCollectingLearnMore2: 'ഡെവലപ്പർമാർ ശേഖരണം എങ്ങനെ പ്രഖ്യാപിക്കുന്നു എന്ന്',
    infoSeeDetails: 'വിശദാംശങ്ങൾ കാണുക',
    descriptionTitle: 'ആപ്പിനെ കുറിച്ച്',
    descriptionMore: 'കൂടുതൽ...',
    descriptionLess: 'കുറവ്',
    changesTitle: 'പുതിയത് എന്താണ്',
    chartsTitle: 'റേറ്റിംഗുകളും അവലോകനങ്ങളും',
    ratingsDescription:
      'റേറ്റിംഗുകളും അവലോകനങ്ങളും സ്ഥിരീകരിച്ചതാണ്; ഇത് നിങ്ങളെപ്പോലെ അതേ തരത്തിലുള്ള ഉപകരണം ഉപയോഗിക്കുന്ന ആളുകളിൽ നിന്ന് വരുന്നതാണ്',
    ratingLikes: 'ആളുകൾക്ക് ഇത് ഉപകാരപ്പെട്ടതായി കണ്ടെത്തി',
    ratingQuestion: 'ഈ അവലോകനം ഉപകാരപ്പെട്ടോ?',
    ratingQuestionYes: 'അതെ',
    ratingQuestionNo: 'ഇല്ല',
    ratingAllReviews: 'എല്ലാ അവലോകനങ്ങളും കാണുക',
    chartsTotal: 'ആകെ',
    additionalTitle: 'കൂടുതൽ വിവരങ്ങൾ',
    additionalUpdatedTitle: 'അപ്‌ഡേറ്റ് ചെയ്തത്',
    additionalSizeTitle: 'വലുപ്പം',
    additionalInstallTitle: 'ഇൻസ്റ്റാളേഷനുകൾ',
    additionalVersionTitle: 'നിലവിലെ പതിപ്പ്',
    additionalAgeTitle: 'പ്രായം',
    additionalDeveloperTitle: 'ഡെവലപ്പർ',
    detailsSupport: 'ആപ്പ് പിന്തുണ',
    detailsPrivacyPolicy: 'സ്വകാര്യതാ നയം',
    googlePlayRefund: 'Google Play റീഫണ്ട് നയം',
    googlePlayVAT: 'എല്ലാ വിലകളിലും GST ഉൾപ്പെടുത്തിയിട്ടുണ്ട്.',
    googlePlayGames: 'ഗെയിംസ്',
    googlePlayApps: 'ആപ്പുകൾ',
    googlePlaySearch: 'തിരയുക',
    googlePlayBooks: 'പുസ്തകങ്ങൾ',
  },
  kn: {
    appAvailability: 'ಈ ಅಪ್ಲಿಕೇಶನ್ ನಿಮ್ಮ ಎಲ್ಲಾ ಸಾಧನಗಳಲ್ಲಿ ಲಭ್ಯವಿದೆ',
    addToWishlist: 'ಇಚ್ಛಾ ಪಟ್ಟಿಗೆ ಸೇರಿಸಿ',
    infoChoice: 'ಸಂಪಾದಕರ ಆಯ್ಕೆ',
    infoWishList: 'ಇಚ್ಛಾ ಪಟ್ಟಿಗೆ ಸೇರಿಸಿ',
    infoAge: 'ವಯಸ್ಸು',
    infoRatedFor: 'ಗಾಗಿ ರೇಟಿಂಗ್',
    infoReviews: 'ವಿಮರ್ಶೆಗಳು',
    infoOpen: 'ತೆರೆಯಿರಿ',
    infoLoading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
    infoDownloads: 'ಡೌನ್‌ಲೋಡ್‌ಗಳು',
    infoInstall: 'ಇನ್‌ಸ್ಟಾಲ್ ಮಾಡಿ',
    infoDownload: 'ಡೌನ್‌ಲೋಡ್',
    infoEditorsChoice: 'ಸಂಪಾದಕರ ಆಯ್ಕೆಗಳು',
    infoAboutGame: 'ಈ ಆಟದ ಬಗ್ಗೆ',
    infoDataSafety: 'ಡೇಟಾ ಭದ್ರತೆ',
    infoDataSafetyDescription:
      'ಅಭಿವೃದ್ಧಿಪಾರರು ನಿಮ್ಮ ಡೇಟಾವನ್ನು ಹೇಗೆ ಸಂಗ್ರಹಿಸಿ ಹಂಚಿಕೊಳ್ಳುತ್ತಾರೆ ಎಂಬುದನ್ನು ತಿಳಿದುಕೊಳ್ಳುವುದರಿಂದ ಭದ್ರತೆ ಪ್ರಾರಂಭವಾಗುತ್ತದೆ. ಗೌಪ್ಯತೆ ಮತ್ತು ಭದ್ರತಾ ಪದ್ಧತಿಗಳು ನಿಮ್ಮ ಬಳಕೆ, ಪ್ರದೇಶ ಮತ್ತು ವಯಸ್ಸಿನ ಮೇಲೆ ಅವಲಂಬಿಸಿರಬಹುದು. ಅಭಿವೃದ್ಧಿಪಾರರು ಈ ಮಾಹಿತಿಯನ್ನು ಒದಗಿಸಿದ್ದಾರೆ ಮತ್ತು ಸಮಯಾನುಸಾರ ಅದನ್ನು ನವೀಕರಿಸಬಹುದು.',
    infoDataSharing: 'ಡೇಟಾವನ್ನು ಮೂರನೇ ವ್ಯಕ್ತಿಗಳೊಂದಿಗೆ ಹಂಚಲಾಗುವುದಿಲ್ಲ',
    infoDataSharingLearnMore1: 'ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ',
    infoDataSharingLearnMore2: 'ಅಭಿವೃದ್ಧಿಪಾರರು ಹಂಚಿಕೆಯನ್ನು ಹೇಗೆ ಘೋಷಿಸುತ್ತಾರೆ ಎಂಬುದರ ಬಗ್ಗೆ',
    infoDataCollecting: 'ಯಾವುದೇ ಡೇಟಾ ಸಂಗ್ರಹಿಸಲಾಗುವುದಿಲ್ಲ',
    infoDataCollectingLearnMore1: 'ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ',
    infoDataCollectingLearnMore2: 'ಅಭಿವೃದ್ಧಿಪಾರರು ಸಂಗ್ರಹಣೆಯನ್ನು ಹೇಗೆ ಘೋಷಿಸುತ್ತಾರೆ ಎಂಬುದರ ಬಗ್ಗೆ',
    infoSeeDetails: 'ವಿವರಗಳನ್ನು ನೋಡಿ',
    descriptionTitle: 'ಅಪ್ಲಿಕೇಶನ್ ಬಗ್ಗೆ',
    descriptionMore: 'ಇನ್ನಷ್ಟು...',
    descriptionLess: 'ಕಡಿಮೆ',
    changesTitle: 'ಹೆಚ್ಚಿನ ಹೊಸದಾಗಿ',
    chartsTitle: 'ರೇಟಿಂಗ್‌ಗಳು ಮತ್ತು ವಿಮರ್ಶೆಗಳು',
    ratingsDescription: 'ರೇಟಿಂಗ್‌ಗಳು ಮತ್ತು ವಿಮರ್ಶೆಗಳು ಪರಿಶೀಲಿತವಾಗಿದ್ದು, ನಿಮ್ಮಂತೆಯೇ ಸಾಧನವನ್ನು ಬಳಸುವವರಿಂದ ಬಂದಿವೆ',
    ratingLikes: 'ಜನರಿಗೆ ಇದು ಸಹಾಯವಾಗಿದೆ',
    ratingQuestion: 'ಈ ವಿಮರ್ಶೆ ಸಹಾಯಕವಾಗಿತ್ತೇ?',
    ratingQuestionYes: 'ಹೌದು',
    ratingQuestionNo: 'ಇಲ್ಲ',
    ratingAllReviews: 'ಎಲ್ಲ ವಿಮರ್ಶೆಗಳನ್ನು ನೋಡಿ',
    chartsTotal: 'ಒಟ್ಟು',
    additionalTitle: 'ಹೆಚ್ಚುವರಿ ಮಾಹಿತಿ',
    additionalUpdatedTitle: 'ನವೀಕರಿಸಲಾಗಿದೆ',
    additionalSizeTitle: 'ಗಾತ್ರ',
    additionalInstallTitle: 'ಇನ್‌ಸ್ಟಾಲೇಶನ್‌ಗಳು',
    additionalVersionTitle: 'ಪ್ರಸ್ತುತ ಆವೃತ್ತಿ',
    additionalAgeTitle: 'ವಯಸ್ಸು',
    additionalDeveloperTitle: 'ಅಭಿವೃದ್ಧಿಪಾರರು',
    detailsSupport: 'ಅಪ್ ಬೆಂಬಲ',
    detailsPrivacyPolicy: 'ಗೌಪ್ಯತಾ ನೀತಿ',
    googlePlayRefund: 'Google Play ಮರುಪಾವತಿ ನೀತಿ',
    googlePlayVAT: 'ಎಲ್ಲ ಬೆಲೆಗಳಲ್ಲಿ GST ಒಳಗೊಂಡಿದೆ.',
    googlePlayGames: 'ಆಟಗಳು',
    googlePlayApps: 'ಅಪ್ಲಿಕೇಶನ್‌ಗಳು',
    googlePlaySearch: 'ಹುಡುಕಾಟ',
    googlePlayBooks: 'ಪುಸ್ತಕಗಳು',
  },
  fa: {
    infoChoice: 'انتخاب سردبیر',
    infoWishList: 'افزودن به لیست علاقه‌مندی‌ها',
    infoAge: 'سن',
    infoRatedFor: 'مناسب برای',
    infoReviews: 'بررسی‌ها',
    appAvailability: 'این برنامه برای تمام دستگاه‌های شما در دسترس است',
    infoOpen: 'باز کردن',
    infoLoading: 'در حال بارگذاری...',
    infoDownloads: 'دانلودها',
    infoInstall: 'نصب',
    addToWishlist: 'افزودن به لیست علاقه‌مندی‌ها',
    infoDownload: 'دانلود',
    infoEditorsChoice: 'انتخاب سردبیران',
    infoAboutGame: 'درباره این بازی',
    infoDataSafety: 'ایمنی داده‌ها',
    infoDataSafetyDescription:
      'ایمنی با درک نحوه جمع‌آوری و اشتراک‌گذاری داده‌های شما توسط توسعه‌دهندگان آغاز می‌شود. شیوه‌های حریم خصوصی و امنیت ممکن است بر اساس استفاده، منطقه و سن شما متفاوت باشد. توسعه‌دهنده این اطلاعات را ارائه داده و ممکن است آن را در طول زمان به‌روزرسانی کند.',
    infoDataSharing: 'هیچ داده‌ای با اشخاص ثالث به اشتراک گذاشته نمی‌شود',
    infoDataSharingLearnMore1: 'بیشتر بدانید',
    infoDataSharingLearnMore2: 'درباره نحوه اعلام اشتراک‌گذاری توسط توسعه‌دهندگان',
    infoDataCollecting: 'هیچ داده‌ای جمع‌آوری نمی‌شود',
    infoDataCollectingLearnMore1: 'بیشتر بدانید',
    infoDataCollectingLearnMore2: 'درباره نحوه اعلام جمع‌آوری توسط توسعه‌دهندگان',
    infoSeeDetails: 'مشاهده جزئیات',
    descriptionTitle: 'درباره برنامه',
    descriptionMore: 'بیشتر...',
    descriptionLess: 'کمتر',
    changesTitle: 'چه چیزی جدید است',
    chartsTitle: 'امتیازات و نظرات',
    ratingsDescription: 'امتیازات و نظرات تأیید شده‌اند و از افرادی هستند که از همان نوع دستگاه شما استفاده می‌کنند',
    ratingLikes: 'نفر این را مفید یافتند',
    ratingQuestion: 'آیا این بررسی مفید بود؟',
    ratingQuestionYes: 'بله',
    ratingQuestionNo: 'خیر',
    ratingAllReviews: 'مشاهده همه بررسی‌ها',
    chartsTotal: 'مجموع',
    additionalTitle: 'اطلاعات اضافی',
    additionalUpdatedTitle: 'به‌روزرسانی',
    additionalSizeTitle: 'اندازه',
    additionalInstallTitle: 'نصب‌ها',
    additionalVersionTitle: 'نسخه فعلی',
    additionalAgeTitle: 'سن',
    additionalDeveloperTitle: 'توسعه‌دهنده',
    detailsSupport: 'پشتیبانی برنامه',
    detailsPrivacyPolicy: 'سیاست حفظ حریم خصوصی',
    googlePlayRefund: 'سیاست بازپرداخت گوگل پلی',
    googlePlayVAT: 'همه قیمت‌ها شامل مالیات بر ارزش افزوده است.',
    googlePlayGames: 'بازی‌ها',
    googlePlayApps: 'برنامه‌ها',
    googlePlaySearch: 'جستجو',
    googlePlayBooks: 'کتاب‌ها',
  },
  my: {
    infoChoice: 'အယ်ဒီတာရွေးချယ်မှု',
    infoWishList: 'ဆန္ဒစာရင်းထည့်ရန်',
    infoAge: 'အသက်',
    infoRatedFor: 'အတွက် အဆင့်သတ်မှတ်ထားသည်',
    infoReviews: 'ပြန်လည်သုံးသပ်ချက်များ',
    appAvailability: 'ဤအပ်ကို သင့်စက်များအားလုံးတွင် အသုံးပြုနိုင်သည်',
    infoOpen: 'ဖွင့်မည်',
    infoLoading: 'လှည့်နေသည်...',
    infoDownloads: 'ဒေါင်းလုဒ်များ',
    infoInstall: 'တပ်ဆင်မည်',
    addToWishlist: 'ဆန္ဒစာရင်းထည့်ရန်',
    infoDownload: 'ဒေါင်းလုဒ်',
    infoEditorsChoice: 'အယ်ဒီတာရွေးချယ်မှုများ',
    infoAboutGame: 'ဤဂိမ်းအကြောင်း',
    infoDataSafety: 'ဒေတာလုံခြုံမှု',
    infoDataSafetyDescription:
      'ဒေတာကို ဘယ်လိုစုဆောင်းပြီး မျှဝေသည်ကို နားလည်ခြင်းမှ စတင်သည်။ သင့်အသုံးပြုမှု၊ နေရာဒေသနှင့် အသက်ပေါ်မူတည်၍ လုံခြုံမှုစည်းမျဉ်းများ ကွဲပြားနိုင်သည်။ ဖန်တီးသူမှ ဤအချက်အလက်များကို ပေးထားပြီး အချိန်အလိုက် အပ်ဒိတ်လုပ်နိုင်သည်။',
    infoDataSharing: 'ဒေတာကို တတိယပတ်ဝန်းကျင်များနှင့် မျှဝေမထားပါ',
    infoDataSharingLearnMore1: 'နောက်ထပ်လေ့လာရန်',
    infoDataSharingLearnMore2: 'ဖန်တီးသူများ မျှဝေမှုကို မည်သို့ ကြေညာသည်ဆိုတာ',
    infoDataCollecting: 'ဒေတာမစုဆောင်းပါ',
    infoDataCollectingLearnMore1: 'နောက်ထပ်လေ့လာရန်',
    infoDataCollectingLearnMore2: 'ဖန်တီးသူများ စုဆောင်းမှုကို မည်သို့ ကြေညာသည်ဆိုတာ',
    infoSeeDetails: 'အသေးစိတ်ကြည့်ရန်',
    descriptionTitle: 'အပ်အကြောင်း',
    descriptionMore: 'နောက်ထပ်...',
    descriptionLess: 'နည်းသော',
    changesTitle: 'အသစ်ပါဝင်သည်များ',
    chartsTitle: 'အဆင့်နှင့် သုံးသပ်ချက်များ',
    ratingsDescription: 'အဆင့်နှင့် သုံးသပ်ချက်များကို အတည်ပြုပြီး သင်အသုံးပြုသည့်စက်အမျိုးအစားတူသူများမှ ဖြစ်သည်',
    ratingLikes: 'လူများအတွက် အထောက်အကူဖြစ်သည်ဟု တွေ့ရသည်',
    ratingQuestion: 'ဤသုံးသပ်ချက် အသုံးဝင်ပါသလား?',
    ratingQuestionYes: 'ဟုတ်ကဲ့',
    ratingQuestionNo: 'မဟုတ်ပါ',
    ratingAllReviews: 'သုံးသပ်ချက်အားလုံးကြည့်ရန်',
    chartsTotal: 'စုစုပေါင်း',
    additionalTitle: 'ထပ်ဆောင်းအချက်အလက်',
    additionalUpdatedTitle: 'အပ်ဒိတ်',
    additionalSizeTitle: 'အရွယ်အစား',
    additionalInstallTitle: 'တပ်ဆင်မှုများ',
    additionalVersionTitle: 'လက်ရှိဗားရှင်း',
    additionalAgeTitle: 'အသက်',
    additionalDeveloperTitle: 'ဖန်တီးသူ',
    detailsSupport: 'အပ်အထောက်အပံ့',
    detailsPrivacyPolicy: 'ကိုယ်ပိုင်အချက်အလက် မူဝါဒ',
    googlePlayRefund: 'Google Play ပြန်အမ်းမူဝါဒ',
    googlePlayVAT: 'စျေးနှုန်းအားလုံးတွင် အခွန်ပါဝင်သည်။',
    googlePlayGames: 'ဂိမ်းများ',
    googlePlayApps: 'အပ်များ',
    googlePlaySearch: 'ရှာဖွေရန်',
    googlePlayBooks: 'စာအုပ်များ',
  },
  nl: {
    infoChoice: 'Keuze van de redactie',
    infoWishList: 'Toevoegen aan verlanglijst',
    infoAge: 'Leeftijd',
    infoRatedFor: 'Beoordeeld voor',
    infoReviews: 'beoordelingen',
    appAvailability: 'Deze app is beschikbaar voor al uw apparaten',
    infoOpen: 'Openen',
    infoLoading: 'Laden...',
    infoDownloads: 'Downloads',
    infoInstall: 'Installeren',
    addToWishlist: 'Toevoegen aan verlanglijst',
    infoDownload: 'Downloaden',
    infoEditorsChoice: 'Keuze van de redactie',
    infoAboutGame: 'Over dit spel',
    infoDataSafety: 'Gegevensbeveiliging',
    infoDataSafetyDescription:
      'Beveiliging begint met inzicht in hoe ontwikkelaars uw gegevens verzamelen en delen. Privacy- en beveiligingspraktijken kunnen variëren afhankelijk van uw gebruik, regio en leeftijd. De ontwikkelaar heeft deze informatie verstrekt en kan deze in de loop der tijd bijwerken.',
    infoDataSharing: 'Geen gegevens gedeeld met derden',
    infoDataSharingLearnMore1: 'Meer informatie',
    infoDataSharingLearnMore2: 'over hoe ontwikkelaars delen verklaren',
    infoDataCollecting: 'Geen gegevens verzameld',
    infoDataCollectingLearnMore1: 'Meer informatie',
    infoDataCollectingLearnMore2: 'over hoe ontwikkelaars verzamelen verklaren',
    infoSeeDetails: 'Details bekijken',
    descriptionTitle: 'Over de app',
    descriptionMore: 'Meer...',
    descriptionLess: 'Minder',
    changesTitle: 'Wat is er nieuw',
    chartsTitle: 'Beoordelingen en recensies',
    ratingsDescription:
      'Beoordelingen en recensies zijn geverifieerd en afkomstig van mensen die hetzelfde type apparaat gebruiken als u',
    ratingLikes: 'mensen vonden dit nuttig',
    ratingQuestion: 'Was deze recensie nuttig?',
    ratingQuestionYes: 'Ja',
    ratingQuestionNo: 'Nee',
    ratingAllReviews: 'Alle recensies bekijken',
    chartsTotal: 'Totaal',
    additionalTitle: 'Aanvullende informatie',
    additionalUpdatedTitle: 'Bijgewerkt',
    additionalSizeTitle: 'Grootte',
    additionalInstallTitle: 'Installaties',
    additionalVersionTitle: 'Huidige versie',
    additionalAgeTitle: 'Leeftijd',
    additionalDeveloperTitle: 'Ontwikkelaar',
    detailsSupport: 'App-ondersteuning',
    detailsPrivacyPolicy: 'Privacybeleid',
    googlePlayRefund: 'Restitutiebeleid Google Play',
    googlePlayVAT: 'Alle prijzen zijn inclusief btw.',
    googlePlayGames: 'Spellen',
    googlePlayApps: 'Apps',
    googlePlaySearch: 'Zoeken',
    googlePlayBooks: 'Boeken',
  },
  ro: {
    infoChoice: 'Alegerea editorului',
    infoWishList: 'Adaugă la lista de dorințe',
    infoAge: 'Vârstă',
    infoRatedFor: 'Evaluat pentru',
    infoReviews: 'recenzii',
    appAvailability: 'Această aplicație este disponibilă pentru toate dispozitivele tale',
    infoOpen: 'Deschide',
    infoLoading: 'Se încarcă...',
    infoDownloads: 'Descărcări',
    infoInstall: 'Instalează',
    addToWishlist: 'Adaugă la lista de dorințe',
    infoDownload: 'Descărcare',
    infoEditorsChoice: 'Alegerea editorilor',
    infoAboutGame: 'Despre acest joc',
    infoDataSafety: 'Securitatea datelor',
    infoDataSafetyDescription:
      'Securitatea începe prin înțelegerea modului în care dezvoltatorii colectează și partajează datele tale. Practicile de confidențialitate și securitate pot varia în funcție de utilizarea ta, regiune și vârstă. Dezvoltatorul a furnizat aceste informații și le poate actualiza în timp.',
    infoDataSharing: 'Nicio dată partajată cu terți',
    infoDataSharingLearnMore1: 'Află mai multe',
    infoDataSharingLearnMore2: 'despre cum declară dezvoltatorii partajarea',
    infoDataCollecting: 'Nu se colectează date',
    infoDataCollectingLearnMore1: 'Află mai multe',
    infoDataCollectingLearnMore2: 'despre cum declară dezvoltatorii colectarea',
    infoSeeDetails: 'Vezi detalii',
    descriptionTitle: 'Despre aplicație',
    descriptionMore: 'Mai mult...',
    descriptionLess: 'Mai puțin',
    changesTitle: 'Ce e nou',
    chartsTitle: 'Evaluări și recenzii',
    ratingsDescription:
      'Evaluările și recenziile sunt verificate și provin de la persoane care folosesc același tip de dispozitiv ca tine',
    ratingLikes: 'oamenii au considerat acest lucru util',
    ratingQuestion: 'Această recenzie a fost utilă?',
    ratingQuestionYes: 'Da',
    ratingQuestionNo: 'Nu',
    ratingAllReviews: 'Vezi toate recenziile',
    chartsTotal: 'Total',
    additionalTitle: 'Informații suplimentare',
    additionalUpdatedTitle: 'Actualizat',
    additionalSizeTitle: 'Dimensiune',
    additionalInstallTitle: 'Instalări',
    additionalVersionTitle: 'Versiunea curentă',
    additionalAgeTitle: 'Vârstă',
    additionalDeveloperTitle: 'Dezvoltator',
    detailsSupport: 'Asistență aplicație',
    detailsPrivacyPolicy: 'Politica de confidențialitate',
    googlePlayRefund: 'Politica de rambursare Google Play',
    googlePlayVAT: 'Toate prețurile includ TVA.',
    googlePlayGames: 'Jocuri',
    googlePlayApps: 'Aplicații',
    googlePlaySearch: 'Căutare',
    googlePlayBooks: 'Cărți',
  },
  cs: {
    infoChoice: 'Volba redakce',
    infoWishList: 'Přidat do seznamu přání',
    infoAge: 'Věk',
    infoRatedFor: 'Určeno pro',
    infoReviews: 'recenze',
    appAvailability: 'Tato aplikace je dostupná pro všechna vaše zařízení',
    infoOpen: 'Otevřít',
    infoLoading: 'Načítání...',
    infoDownloads: 'Stažení',
    infoInstall: 'Instalovat',
    addToWishlist: 'Přidat do seznamu přání',
    infoDownload: 'Stáhnout',
    infoEditorsChoice: 'Volba editorů',
    infoAboutGame: 'O této hře',
    infoDataSafety: 'Bezpečnost dat',
    infoDataSafetyDescription:
      'Bezpečnost začíná pochopením toho, jak vývojáři shromažďují a sdílejí vaše data. Postupy ochrany soukromí a bezpečnosti se mohou lišit v závislosti na vašem použití, oblasti a věku. Vývojář tyto informace poskytl a může je časem aktualizovat.',
    infoDataSharing: 'Žádná data nejsou sdílena s třetími stranami',
    infoDataSharingLearnMore1: 'Zjistit více',
    infoDataSharingLearnMore2: 'o tom, jak vývojáři oznamují sdílení',
    infoDataCollecting: 'Žádná data nejsou shromažďována',
    infoDataCollectingLearnMore1: 'Zjistit více',
    infoDataCollectingLearnMore2: 'o tom, jak vývojáři oznamují shromažďování',
    infoSeeDetails: 'Zobrazit podrobnosti',
    descriptionTitle: 'O aplikaci',
    descriptionMore: 'Více...',
    descriptionLess: 'Méně',
    changesTitle: 'Co je nového',
    chartsTitle: 'Hodnocení a recenze',
    ratingsDescription:
      'Hodnocení a recenze jsou ověřené a pocházejí od lidí, kteří používají stejný typ zařízení jako vy',
    ratingLikes: 'lidem to přišlo užitečné',
    ratingQuestion: 'Byla tato recenze užitečná?',
    ratingQuestionYes: 'Ano',
    ratingQuestionNo: 'Ne',
    ratingAllReviews: 'Zobrazit všechny recenze',
    chartsTotal: 'Celkem',
    additionalTitle: 'Další informace',
    additionalUpdatedTitle: 'Aktualizováno',
    additionalSizeTitle: 'Velikost',
    additionalInstallTitle: 'Instalace',
    additionalVersionTitle: 'Aktuální verze',
    additionalAgeTitle: 'Věk',
    additionalDeveloperTitle: 'Vývojář',
    detailsSupport: 'Podpora aplikace',
    detailsPrivacyPolicy: 'Zásady ochrany osobních údajů',
    googlePlayRefund: 'Pravidla vrácení peněz Google Play',
    googlePlayVAT: 'Všechny ceny zahrnují DPH.',
    googlePlayGames: 'Hry',
    googlePlayApps: 'Aplikace',
    googlePlaySearch: 'Hledat',
    googlePlayBooks: 'Knihy',
  },
  hu: {
    infoChoice: 'Szerkesztő választása',
    infoWishList: 'Hozzáadás a kívánságlistához',
    infoAge: 'Kor',
    infoRatedFor: 'Értékelve',
    infoReviews: 'értékelés',
    appAvailability: 'Ez az alkalmazás elérhető az összes eszközödön',
    infoOpen: 'Megnyitás',
    infoLoading: 'Betöltés...',
    infoDownloads: 'Letöltések',
    infoInstall: 'Telepítés',
    addToWishlist: 'Hozzáadás a kívánságlistához',
    infoDownload: 'Letöltés',
    infoEditorsChoice: 'Szerkesztő választása',
    infoAboutGame: 'Az alkalmazásról',
    infoDataSafety: 'Adatbiztonság',
    infoDataSafetyDescription:
      'A biztonság azzal kezdődik, hogy megérted, hogyan gyűjtik és osztják meg adataidat a fejlesztők. Az adatvédelmi és biztonsági gyakorlatok használattól, régiótól és kortól függően eltérhetnek. A fejlesztő adta meg ezeket az információkat, és idővel frissítheti őket.',
    infoDataSharing: 'Nincs adatmegosztás harmadik felekkel',
    infoDataSharingLearnMore1: 'Tudj meg többet',
    infoDataSharingLearnMore2: 'arról, hogyan jelentik be a fejlesztők a megosztást',
    infoDataCollecting: 'Nincs adatgyűjtés',
    infoDataCollectingLearnMore1: 'Tudj meg többet',
    infoDataCollectingLearnMore2: 'arról, hogyan jelentik be a fejlesztők a gyűjtést',
    infoSeeDetails: 'Részletek megtekintése',
    descriptionTitle: 'Az alkalmazásról',
    descriptionMore: 'Több...',
    descriptionLess: 'Kevesebb',
    changesTitle: 'Újdonságok',
    chartsTitle: 'Értékelések és vélemények',
    ratingsDescription:
      'Az értékelések és vélemények ellenőrzöttek, és olyan emberektől származnak, akik ugyanazt az eszközt használják, mint te',
    ratingLikes: 'embernek volt hasznos',
    ratingQuestion: 'Hasznos volt ez az értékelés?',
    ratingQuestionYes: 'Igen',
    ratingQuestionNo: 'Nem',
    ratingAllReviews: 'Összes vélemény megtekintése',
    chartsTotal: 'Összesen',
    additionalTitle: 'További információk',
    additionalUpdatedTitle: 'Frissítve',
    additionalSizeTitle: 'Méret',
    additionalInstallTitle: 'Telepítések',
    additionalVersionTitle: 'Aktuális verzió',
    additionalAgeTitle: 'Kor',
    additionalDeveloperTitle: 'Fejlesztő',
    detailsSupport: 'Alkalmazás támogatása',
    detailsPrivacyPolicy: 'Adatvédelmi irányelvek',
    googlePlayRefund: 'Google Play visszatérítési szabályzat',
    googlePlayVAT: 'Minden ár tartalmazza az ÁFÁ-t.',
    googlePlayGames: 'Játékok',
    googlePlayApps: 'Alkalmazások',
    googlePlaySearch: 'Keresés',
    googlePlayBooks: 'Könyvek',
  },
  el: {
    infoChoice: 'Επιλογή συντάκτη',
    infoWishList: 'Προσθήκη στη λίστα επιθυμιών',
    infoAge: 'Ηλικία',
    infoRatedFor: 'Βαθμολογήθηκε για',
    infoReviews: 'κριτικές',
    appAvailability: 'Αυτή η εφαρμογή είναι διαθέσιμη για όλες τις συσκευές σας',
    infoOpen: 'Άνοιγμα',
    infoLoading: 'Φόρτωση...',
    infoDownloads: 'Λήψεις',
    infoInstall: 'Εγκατάσταση',
    addToWishlist: 'Προσθήκη στη λίστα επιθυμιών',
    infoDownload: 'Λήψη',
    infoEditorsChoice: 'Επιλογή συντάκτη',
    infoAboutGame: 'Σχετικά με την εφαρμογή',
    infoDataSafety: 'Ασφάλεια δεδομένων',
    infoDataSafetyDescription:
      'Η ασφάλεια ξεκινά με την κατανόηση του πώς οι προγραμματιστές συλλέγουν και κοινοποιούν τα δεδομένα σας. Οι πρακτικές απορρήτου και ασφάλειας μπορεί να διαφέρουν ανάλογα με τη χρήση, την περιοχή και την ηλικία. Ο προγραμματιστής παρείχε αυτές τις πληροφορίες και μπορεί να τις ενημερώνει με την πάροδο του χρόνου.',
    infoDataSharing: 'Δεν κοινοποιούνται δεδομένα σε τρίτους',
    infoDataSharingLearnMore1: 'Μάθε περισσότερα',
    infoDataSharingLearnMore2: 'σχετικά με τον τρόπο δήλωσης της κοινοποίησης',
    infoDataCollecting: 'Δεν συλλέγονται δεδομένα',
    infoDataCollectingLearnMore1: 'Μάθε περισσότερα',
    infoDataCollectingLearnMore2: 'σχετικά με τον τρόπο δήλωσης της συλλογής',
    infoSeeDetails: 'Δείτε λεπτομέρειες',
    descriptionTitle: 'Σχετικά με την εφαρμογή',
    descriptionMore: 'Περισσότερα...',
    descriptionLess: 'Λιγότερα',
    changesTitle: 'Τι νέο υπάρχει',
    chartsTitle: 'Βαθμολογίες και κριτικές',
    ratingsDescription:
      'Οι αξιολογήσεις και οι κριτικές είναι επαληθευμένες και προέρχονται από άτομα που χρησιμοποιούν τον ίδιο τύπο συσκευής όπως εσείς',
    ratingLikes: 'άτομα το βρήκαν χρήσιμο',
    ratingQuestion: 'Ήταν χρήσιμη αυτή η κριτική;',
    ratingQuestionYes: 'Ναι',
    ratingQuestionNo: 'Όχι',
    ratingAllReviews: 'Δείτε όλες τις κριτικές',
    chartsTotal: 'Σύνολο',
    additionalTitle: 'Πρόσθετες πληροφορίες',
    additionalUpdatedTitle: 'Ενημερώθηκε',
    additionalSizeTitle: 'Μέγεθος',
    additionalInstallTitle: 'Εγκαταστάσεις',
    additionalVersionTitle: 'Τρέχουσα έκδοση',
    additionalAgeTitle: 'Ηλικία',
    additionalDeveloperTitle: 'Προγραμματιστής',
    detailsSupport: 'Υποστήριξη εφαρμογής',
    detailsPrivacyPolicy: 'Πολιτική απορρήτου',
    googlePlayRefund: 'Πολιτική επιστροφής χρημάτων Google Play',
    googlePlayVAT: 'Όλες οι τιμές περιλαμβάνουν ΦΠΑ.',
    googlePlayGames: 'Παιχνίδια',
    googlePlayApps: 'Εφαρμογές',
    googlePlaySearch: 'Αναζήτηση',
    googlePlayBooks: 'Βιβλία',
  },
  sv: {
    infoChoice: 'Redaktionens val',
    infoWishList: 'Lägg till i önskelistan',
    infoAge: 'Ålder',
    infoRatedFor: 'Betygsatt för',
    infoReviews: 'recensioner',
    appAvailability: 'Denna app är tillgänglig för alla dina enheter',
    infoOpen: 'Öppna',
    infoLoading: 'Laddar...',
    infoDownloads: 'Nedladdningar',
    infoInstall: 'Installera',
    addToWishlist: 'Lägg till i önskelistan',
    infoDownload: 'Ladda ner',
    infoEditorsChoice: 'Redaktionens val',
    infoAboutGame: 'Om appen',
    infoDataSafety: 'Datasäkerhet',
    infoDataSafetyDescription:
      'Säkerhet börjar med att förstå hur utvecklare samlar in och delar dina data. Dataskydds- och säkerhetsrutiner kan variera beroende på användning, region och ålder. Utvecklaren har tillhandahållit denna information och kan uppdatera den över tid.',
    infoDataSharing: 'Inga data delas med tredje part',
    infoDataSharingLearnMore1: 'Läs mer',
    infoDataSharingLearnMore2: 'om hur utvecklare deklarerar delning',
    infoDataCollecting: 'Ingen datainsamling',
    infoDataCollectingLearnMore1: 'Läs mer',
    infoDataCollectingLearnMore2: 'om hur utvecklare deklarerar insamling',
    infoSeeDetails: 'Se detaljer',
    descriptionTitle: 'Om appen',
    descriptionMore: 'Mer...',
    descriptionLess: 'Mindre',
    changesTitle: 'Nyheter',
    chartsTitle: 'Betyg och recensioner',
    ratingsDescription:
      'Betyg och recensioner är verifierade och kommer från personer som använder samma typ av enhet som du',
    ratingLikes: 'personer tyckte detta var hjälpsamt',
    ratingQuestion: 'Var denna recension hjälpsam?',
    ratingQuestionYes: 'Ja',
    ratingQuestionNo: 'Nej',
    ratingAllReviews: 'Se alla recensioner',
    chartsTotal: 'Totalt',
    additionalTitle: 'Ytterligare information',
    additionalUpdatedTitle: 'Uppdaterad',
    additionalSizeTitle: 'Storlek',
    additionalInstallTitle: 'Installationer',
    additionalVersionTitle: 'Aktuell version',
    additionalAgeTitle: 'Ålder',
    additionalDeveloperTitle: 'Utvecklare',
    detailsSupport: 'Appsupport',
    detailsPrivacyPolicy: 'Integritetspolicy',
    googlePlayRefund: 'Google Plays återbetalningspolicy',
    googlePlayVAT: 'Alla priser inkluderar moms.',
    googlePlayGames: 'Spel',
    googlePlayApps: 'Appar',
    googlePlaySearch: 'Sök',
    googlePlayBooks: 'Böcker',
  },
  id: {
    infoChoice: 'Pilihan Editor',
    infoWishList: 'Tambahkan ke daftar keinginan',
    infoAge: 'Usia',
    infoRatedFor: 'Dinilai untuk',
    infoReviews: 'ulasan',
    appAvailability: 'Aplikasi ini tersedia untuk semua perangkat Anda',
    infoOpen: 'Buka',
    infoLoading: 'Memuat...',
    infoDownloads: 'Unduhan',
    infoInstall: 'Instal',
    addToWishlist: 'Tambahkan ke daftar keinginan',
    infoDownload: 'Unduh',
    infoEditorsChoice: 'Pilihan Editor',
    infoAboutGame: 'Tentang aplikasi',
    infoDataSafety: 'Keamanan data',
    infoDataSafetyDescription:
      'Keamanan dimulai dengan memahami bagaimana pengembang mengumpulkan dan membagikan data Anda. Praktik privasi dan keamanan data dapat bervariasi berdasarkan penggunaan, wilayah, dan usia. Pengembang menyediakan informasi ini dan dapat memperbaruinya dari waktu ke waktu.',
    infoDataSharing: 'Tidak ada data yang dibagikan dengan pihak ketiga',
    infoDataSharingLearnMore1: 'Pelajari lebih lanjut',
    infoDataSharingLearnMore2: 'tentang bagaimana pengembang menyatakan berbagi',
    infoDataCollecting: 'Tidak ada data yang dikumpulkan',
    infoDataCollectingLearnMore1: 'Pelajari lebih lanjut',
    infoDataCollectingLearnMore2: 'tentang bagaimana pengembang menyatakan pengumpulan',
    infoSeeDetails: 'Lihat detail',
    descriptionTitle: 'Tentang aplikasi',
    descriptionMore: 'Lebih banyak...',
    descriptionLess: 'Lebih sedikit',
    changesTitle: 'Apa yang baru',
    chartsTitle: 'Peringkat dan ulasan',
    ratingsDescription:
      'Peringkat dan ulasan diverifikasi dan berasal dari orang-orang yang menggunakan jenis perangkat yang sama dengan Anda',
    ratingLikes: 'orang merasa ini bermanfaat',
    ratingQuestion: 'Apakah ulasan ini membantu?',
    ratingQuestionYes: 'Ya',
    ratingQuestionNo: 'Tidak',
    ratingAllReviews: 'Lihat semua ulasan',
    chartsTotal: 'Total',
    additionalTitle: 'Informasi tambahan',
    additionalUpdatedTitle: 'Diperbarui',
    additionalSizeTitle: 'Ukuran',
    additionalInstallTitle: 'Instalasi',
    additionalVersionTitle: 'Versi saat ini',
    additionalAgeTitle: 'Usia',
    additionalDeveloperTitle: 'Pengembang',
    detailsSupport: 'Dukungan aplikasi',
    detailsPrivacyPolicy: 'Kebijakan privasi',
    googlePlayRefund: 'Kebijakan pengembalian dana Google Play',
    googlePlayVAT: 'Semua harga sudah termasuk PPN.',
    googlePlayGames: 'Game',
    googlePlayApps: 'Aplikasi',
    googlePlaySearch: 'Cari',
    googlePlayBooks: 'Buku',
  },
  he: {
    infoChoice: 'בחירת העורך',
    infoWishList: 'הוסף לרשימת המשאלות',
    infoAge: 'גיל',
    infoRatedFor: 'מדורג עבור',
    infoReviews: 'ביקורות',
    appAvailability: 'האפליקציה זמינה לכל המכשירים שלך',
    infoOpen: 'פתח',
    infoLoading: 'טוען...',
    infoDownloads: 'הורדות',
    infoInstall: 'התקן',
    addToWishlist: 'הוסף לרשימת המשאלות',
    infoDownload: 'הורד',
    infoEditorsChoice: 'בחירת העורך',
    infoAboutGame: 'על האפליקציה',
    infoDataSafety: 'אבטחת נתונים',
    infoDataSafetyDescription:
      'האבטחה מתחילה בהבנת הדרך שבה מפתחים אוספים ומשתפים את הנתונים שלך. נוהלי פרטיות ואבטחה עשויים להשתנות בהתאם לשימוש, אזור וגיל. המפתח סיפק מידע זה ויכול לעדכן אותו עם הזמן.',
    infoDataSharing: 'אין שיתוף נתונים עם צדדים שלישיים',
    infoDataSharingLearnMore1: 'למד עוד',
    infoDataSharingLearnMore2: 'על איך מפתחים מצהירים על שיתוף',
    infoDataCollecting: 'לא נאספו נתונים',
    infoDataCollectingLearnMore1: 'למד עוד',
    infoDataCollectingLearnMore2: 'על איך מפתחים מצהירים על איסוף',
    infoSeeDetails: 'ראה פרטים',
    descriptionTitle: 'על האפליקציה',
    descriptionMore: 'עוד...',
    descriptionLess: 'פחות',
    changesTitle: 'מה חדש',
    chartsTitle: 'דירוגים וביקורות',
    ratingsDescription: 'הדירוגים והביקורות מאומתים ומגיעים מאנשים שמשתמשים באותו סוג מכשיר כמוך',
    ratingLikes: 'אנשים מצאו את זה מועיל',
    ratingQuestion: 'האם הביקורת הזו הייתה מועילה?',
    ratingQuestionYes: 'כן',
    ratingQuestionNo: 'לא',
    ratingAllReviews: 'ראה את כל הביקורות',
    chartsTotal: 'סה״כ',
    additionalTitle: 'מידע נוסף',
    additionalUpdatedTitle: 'עודכן',
    additionalSizeTitle: 'גודל',
    additionalInstallTitle: 'התקנות',
    additionalVersionTitle: 'גרסה נוכחית',
    additionalAgeTitle: 'גיל',
    additionalDeveloperTitle: 'מפתח',
    detailsSupport: 'תמיכת אפליקציה',
    detailsPrivacyPolicy: 'מדיניות פרטיות',
    googlePlayRefund: 'מדיניות החזרות של Google Play',
    googlePlayVAT: 'כל המחירים כוללים מע״מ.',
    googlePlayGames: 'משחקים',
    googlePlayApps: 'אפליקציות',
    googlePlaySearch: 'חיפוש',
    googlePlayBooks: 'ספרים',
  },
  bg: {
    infoChoice: 'Избор на редактора',
    infoWishList: 'Добавяне в списъка с желания',
    infoAge: 'Възраст',
    infoRatedFor: 'Оценено за',
    infoReviews: 'отзиви',
    appAvailability: 'Това приложение е достъпно за всички ваши устройства',
    infoOpen: 'Отвори',
    infoLoading: 'Зареждане...',
    infoDownloads: 'Изтегляния',
    infoInstall: 'Инсталирай',
    addToWishlist: 'Добави в списъка с желания',
    infoDownload: 'Изтегли',
    infoEditorsChoice: 'Избор на редактора',
    infoAboutGame: 'За тази игра',
    infoDataSafety: 'Сигурност на данните',
    infoDataSafetyDescription:
      'Сигурността започва с разбирането как разработчиците събират и споделят вашите данни. Практиките за поверителност и сигурност могат да се различават в зависимост от вашата употреба, регион и възраст. Разработчикът е предоставил тази информация и може да я актуализира с времето.',
    infoDataSharing: 'Няма споделяне на данни с трети страни',
    infoDataSharingLearnMore1: 'Научете повече',
    infoDataSharingLearnMore2: 'как разработчиците декларират споделяне',
    infoDataCollecting: 'Няма събиране на данни',
    infoDataCollectingLearnMore1: 'Научете повече',
    infoDataCollectingLearnMore2: 'как разработчиците декларират събиране',
    infoSeeDetails: 'Виж подробности',
    descriptionTitle: 'За приложението',
    descriptionMore: 'Още...',
    descriptionLess: 'По-малко',
    changesTitle: 'Какво ново',
    chartsTitle: 'Оценки и отзиви',
    ratingsDescription: 'Оценките и отзивите са проверени и са от хора, които използват същия тип устройство като вас',
    ratingLikes: 'хората намериха това за полезно',
    ratingQuestion: 'Беше ли полезен този отзив?',
    ratingQuestionYes: 'Да',
    ratingQuestionNo: 'Не',
    ratingAllReviews: 'Виж всички отзиви',
    chartsTotal: 'Общо',
    additionalTitle: 'Допълнителна информация',
    additionalUpdatedTitle: 'Актуализирано',
    additionalSizeTitle: 'Размер',
    additionalInstallTitle: 'Инсталации',
    additionalVersionTitle: 'Текуща версия',
    additionalAgeTitle: 'Възраст',
    additionalDeveloperTitle: 'Разработчик',
    detailsSupport: 'Поддръжка на приложението',
    detailsPrivacyPolicy: 'Политика за поверителност',
    googlePlayRefund: 'Политика за възстановяване на Google Play',
    googlePlayVAT: 'Всички цени включват ДДС.',
    googlePlayGames: 'Игри',
    googlePlayApps: 'Приложения',
    googlePlaySearch: 'Търсене',
    googlePlayBooks: 'Книги',
  },
  da: {
    infoChoice: 'Redaktørens valg',
    infoWishList: 'Føj til ønskeliste',
    infoAge: 'Alder',
    infoRatedFor: 'Bedømt til',
    infoReviews: 'anmeldelser',
    appAvailability: 'Denne app er tilgængelig for alle dine enheder',
    infoOpen: 'Åbn',
    infoLoading: 'Indlæser...',
    infoDownloads: 'Downloads',
    infoInstall: 'Installer',
    addToWishlist: 'Føj til ønskeliste',
    infoDownload: 'Download',
    infoEditorsChoice: 'Redaktørens valg',
    infoAboutGame: 'Om dette spil',
    infoDataSafety: 'Datasikkerhed',
    infoDataSafetyDescription:
      'Sikkerhed starter med at forstå, hvordan udviklere indsamler og deler dine data. Privatlivs- og sikkerhedspraksis kan variere afhængigt af din brug, region og alder. Udvikleren har givet disse oplysninger og kan opdatere dem over tid.',
    infoDataSharing: 'Ingen data deles med tredjeparter',
    infoDataSharingLearnMore1: 'Lær mere',
    infoDataSharingLearnMore2: 'om hvordan udviklere erklærer deling',
    infoDataCollecting: 'Ingen data indsamlet',
    infoDataCollectingLearnMore1: 'Lær mere',
    infoDataCollectingLearnMore2: 'om hvordan udviklere erklærer indsamling',
    infoSeeDetails: 'Se detaljer',
    descriptionTitle: 'Om appen',
    descriptionMore: 'Mere...',
    descriptionLess: 'Mindre',
    changesTitle: 'Nyheder',
    chartsTitle: 'Bedømmelser og anmeldelser',
    ratingsDescription:
      'Bedømmelser og anmeldelser er verificeret og kommer fra personer, der bruger samme type enhed som dig',
    ratingLikes: 'folk fandt dette nyttigt',
    ratingQuestion: 'Var denne anmeldelse nyttig?',
    ratingQuestionYes: 'Ja',
    ratingQuestionNo: 'Nej',
    ratingAllReviews: 'Se alle anmeldelser',
    chartsTotal: 'I alt',
    additionalTitle: 'Yderligere information',
    additionalUpdatedTitle: 'Opdateret',
    additionalSizeTitle: 'Størrelse',
    additionalInstallTitle: 'Installationer',
    additionalVersionTitle: 'Nuværende version',
    additionalAgeTitle: 'Alder',
    additionalDeveloperTitle: 'Udvikler',
    detailsSupport: 'App-support',
    detailsPrivacyPolicy: 'Privatlivspolitik',
    googlePlayRefund: 'Google Plays refusionspolitik',
    googlePlayVAT: 'Alle priser inkluderer moms.',
    googlePlayGames: 'Spil',
    googlePlayApps: 'Apps',
    googlePlaySearch: 'Søg',
    googlePlayBooks: 'Bøger',
  },
  fi: {
    infoChoice: 'Toimituksen valinta',
    infoWishList: 'Lisää toivelistalle',
    infoAge: 'Ikä',
    infoRatedFor: 'Arvioitu ikä',
    infoReviews: 'arvostelua',
    appAvailability: 'Tämä sovellus on saatavilla kaikille laitteillesi',
    infoOpen: 'Avaa',
    infoLoading: 'Ladataan...',
    infoDownloads: 'Lataukset',
    infoInstall: 'Asenna',
    addToWishlist: 'Lisää toivelistalle',
    infoDownload: 'Lataa',
    infoEditorsChoice: 'Toimituksen valinta',
    infoAboutGame: 'Tietoja tästä pelistä',
    infoDataSafety: 'Tietoturva',
    infoDataSafetyDescription:
      'Tietoturva alkaa ymmärtämällä, miten kehittäjät keräävät ja jakavat tietojasi. Tietosuoja- ja turvallisuuskäytännöt voivat vaihdella käytön, alueen ja iän mukaan. Kehittäjä on antanut nämä tiedot ja voi päivittää niitä ajan myötä.',
    infoDataSharing: 'Ei tietojen jakamista kolmansille osapuolille',
    infoDataSharingLearnMore1: 'Lisätietoja',
    infoDataSharingLearnMore2: 'siitä, miten kehittäjät ilmoittavat jakamisesta',
    infoDataCollecting: 'Tietoja ei kerätä',
    infoDataCollectingLearnMore1: 'Lisätietoja',
    infoDataCollectingLearnMore2: 'siitä, miten kehittäjät ilmoittavat keräämisestä',
    infoSeeDetails: 'Katso tiedot',
    descriptionTitle: 'Tietoja sovelluksesta',
    descriptionMore: 'Lisää...',
    descriptionLess: 'Vähemmän',
    changesTitle: 'Mitä uutta',
    chartsTitle: 'Arvostelut ja arviot',
    ratingsDescription:
      'Arviot ja arvostelut on vahvistettu, ja ne ovat henkilöiltä, jotka käyttävät samaa laitetyyppiä kuin sinä',
    ratingLikes: 'ihmiset pitivät tätä hyödyllisenä',
    ratingQuestion: 'Oliko tämä arvostelu hyödyllinen?',
    ratingQuestionYes: 'Kyllä',
    ratingQuestionNo: 'Ei',
    ratingAllReviews: 'Katso kaikki arvostelut',
    chartsTotal: 'Yhteensä',
    additionalTitle: 'Lisätietoja',
    additionalUpdatedTitle: 'Päivitetty',
    additionalSizeTitle: 'Koko',
    additionalInstallTitle: 'Asennuksia',
    additionalVersionTitle: 'Nykyinen versio',
    additionalAgeTitle: 'Ikä',
    additionalDeveloperTitle: 'Kehittäjä',
    detailsSupport: 'Sovellustuki',
    detailsPrivacyPolicy: 'Tietosuojakäytäntö',
    googlePlayRefund: 'Google Playn palautuskäytäntö',
    googlePlayVAT: 'Kaikki hinnat sisältävät arvonlisäveron.',
    googlePlayGames: 'Pelit',
    googlePlayApps: 'Sovellukset',
    googlePlaySearch: 'Haku',
    googlePlayBooks: 'Kirjat',
  },
  sk: {
    infoChoice: 'Výber redakcie',
    infoWishList: 'Pridať do zoznamu želaní',
    infoAge: 'Vek',
    infoRatedFor: 'Určené pre',
    infoReviews: 'recenzie',
    appAvailability: 'Táto aplikácia je dostupná pre všetky vaše zariadenia',
    infoOpen: 'Otvoriť',
    infoLoading: 'Načítava sa...',
    infoDownloads: 'Stiahnutia',
    infoInstall: 'Nainštalovať',
    addToWishlist: 'Pridať do zoznamu želaní',
    infoDownload: 'Stiahnuť',
    infoEditorsChoice: 'Výber redakcie',
    infoAboutGame: 'O tejto hre',
    infoDataSafety: 'Bezpečnosť údajov',
    infoDataSafetyDescription:
      'Bezpečnosť začína pochopením toho, ako vývojári zhromažďujú a zdieľajú vaše údaje. Postupy ochrany súkromia a bezpečnosti sa môžu líšiť v závislosti od použitia, regiónu a veku. Vývojár poskytol tieto informácie a môže ich časom aktualizovať.',
    infoDataSharing: 'Žiadne údaje sa nezdieľajú s tretími stranami',
    infoDataSharingLearnMore1: 'Viac informácií',
    infoDataSharingLearnMore2: 'o tom, ako vývojári deklarujú zdieľanie',
    infoDataCollecting: 'Žiadne údaje sa nezhromažďujú',
    infoDataCollectingLearnMore1: 'Viac informácií',
    infoDataCollectingLearnMore2: 'o tom, ako vývojári deklarujú zhromažďovanie',
    infoSeeDetails: 'Zobraziť podrobnosti',
    descriptionTitle: 'O aplikácii',
    descriptionMore: 'Viac...',
    descriptionLess: 'Menej',
    changesTitle: 'Čo je nové',
    chartsTitle: 'Hodnotenia a recenzie',
    ratingsDescription:
      'Hodnotenia a recenzie sú overené a pochádzajú od ľudí, ktorí používajú rovnaký typ zariadenia ako vy',
    ratingLikes: 'ľudia to považovali za užitočné',
    ratingQuestion: 'Bola táto recenzia užitočná?',
    ratingQuestionYes: 'Áno',
    ratingQuestionNo: 'Nie',
    ratingAllReviews: 'Zobraziť všetky recenzie',
    chartsTotal: 'Spolu',
    additionalTitle: 'Ďalšie informácie',
    additionalUpdatedTitle: 'Aktualizované',
    additionalSizeTitle: 'Veľkosť',
    additionalInstallTitle: 'Inštalácie',
    additionalVersionTitle: 'Aktuálna verzia',
    additionalAgeTitle: 'Vek',
    additionalDeveloperTitle: 'Vývojár',
    detailsSupport: 'Podpora aplikácie',
    detailsPrivacyPolicy: 'Zásady ochrany osobných údajov',
    googlePlayRefund: 'Pravidlá vrátenia peňazí Google Play',
    googlePlayVAT: 'Všetky ceny zahŕňajú DPH.',
    googlePlayGames: 'Hry',
    googlePlayApps: 'Aplikácie',
    googlePlaySearch: 'Hľadať',
    googlePlayBooks: 'Knihy',
  },
  no: {
    infoChoice: 'Redaktørens valg',
    infoWishList: 'Legg til i ønskeliste',
    infoAge: 'Alder',
    infoRatedFor: 'Vurdert for',
    infoReviews: 'anmeldelser',
    appAvailability: 'Denne appen er tilgjengelig for alle enhetene dine',
    infoOpen: 'Åpne',
    infoLoading: 'Laster...',
    infoDownloads: 'Nedlastinger',
    infoInstall: 'Installer',
    addToWishlist: 'Legg til i ønskeliste',
    infoDownload: 'Last ned',
    infoEditorsChoice: 'Redaktørens valg',
    infoAboutGame: 'Om dette spillet',
    infoDataSafety: 'Datasikkerhet',
    infoDataSafetyDescription:
      'Sikkerhet starter med å forstå hvordan utviklere samler inn og deler dataene dine. Personvern- og sikkerhetspraksis kan variere basert på din bruk, region og alder. Utvikleren har gitt denne informasjonen og kan oppdatere den over tid.',
    infoDataSharing: 'Ingen data deles med tredjeparter',
    infoDataSharingLearnMore1: 'Les mer',
    infoDataSharingLearnMore2: 'om hvordan utviklere erklærer deling',
    infoDataCollecting: 'Ingen data samlet inn',
    infoDataCollectingLearnMore1: 'Les mer',
    infoDataCollectingLearnMore2: 'om hvordan utviklere erklærer innsamling',
    infoSeeDetails: 'Se detaljer',
    descriptionTitle: 'Om appen',
    descriptionMore: 'Mer...',
    descriptionLess: 'Mindre',
    changesTitle: 'Hva er nytt',
    chartsTitle: 'Vurderinger og anmeldelser',
    ratingsDescription:
      'Vurderinger og anmeldelser er bekreftet og kommer fra personer som bruker samme type enhet som deg',
    ratingLikes: 'folk syntes dette var nyttig',
    ratingQuestion: 'Var denne anmeldelsen nyttig?',
    ratingQuestionYes: 'Ja',
    ratingQuestionNo: 'Nei',
    ratingAllReviews: 'Se alle anmeldelser',
    chartsTotal: 'Totalt',
    additionalTitle: 'Tilleggsinformasjon',
    additionalUpdatedTitle: 'Oppdatert',
    additionalSizeTitle: 'Størrelse',
    additionalInstallTitle: 'Installasjoner',
    additionalVersionTitle: 'Gjeldende versjon',
    additionalAgeTitle: 'Alder',
    additionalDeveloperTitle: 'Utvikler',
    detailsSupport: 'App-støtte',
    detailsPrivacyPolicy: 'Personvernerklæring',
    googlePlayRefund: 'Google Plays refusjonspolicy',
    googlePlayVAT: 'Alle priser inkluderer MVA.',
    googlePlayGames: 'Spill',
    googlePlayApps: 'Apper',
    googlePlaySearch: 'Søk',
    googlePlayBooks: 'Bøker',
  },
  hr: {
    infoChoice: 'Urednikov izbor',
    infoWishList: 'Dodaj na popis želja',
    infoAge: 'Dob',
    infoRatedFor: 'Ocijenjeno za',
    infoReviews: 'recenzije',
    appAvailability: 'Ova aplikacija dostupna je za sve vaše uređaje',
    infoOpen: 'Otvori',
    infoLoading: 'Učitavanje...',
    infoDownloads: 'Preuzimanja',
    infoInstall: 'Instaliraj',
    addToWishlist: 'Dodaj na popis želja',
    infoDownload: 'Preuzmi',
    infoEditorsChoice: 'Urednikov izbor',
    infoAboutGame: 'O ovoj igri',
    infoDataSafety: 'Sigurnost podataka',
    infoDataSafetyDescription:
      'Sigurnost počinje razumijevanjem načina na koji programeri prikupljaju i dijele vaše podatke. Prakse privatnosti i sigurnosti mogu se razlikovati ovisno o vašoj upotrebi, regiji i dobi. Programer je pružio ove informacije i može ih ažurirati tijekom vremena.',
    infoDataSharing: 'Nema dijeljenja podataka s trećim stranama',
    infoDataSharingLearnMore1: 'Saznaj više',
    infoDataSharingLearnMore2: 'o tome kako programeri prijavljuju dijeljenje',
    infoDataCollecting: 'Nema prikupljanja podataka',
    infoDataCollectingLearnMore1: 'Saznaj više',
    infoDataCollectingLearnMore2: 'o tome kako programeri prijavljuju prikupljanje',
    infoSeeDetails: 'Pogledaj detalje',
    descriptionTitle: 'O aplikaciji',
    descriptionMore: 'Više...',
    descriptionLess: 'Manje',
    changesTitle: 'Što je novo',
    chartsTitle: 'Ocjene i recenzije',
    ratingsDescription: 'Ocjene i recenzije su potvrđene i dolaze od osoba koje koriste isti tip uređaja kao i vi',
    ratingLikes: 'osoba smatra da je ovo korisno',
    ratingQuestion: 'Je li ova recenzija bila korisna?',
    ratingQuestionYes: 'Da',
    ratingQuestionNo: 'Ne',
    ratingAllReviews: 'Pogledaj sve recenzije',
    chartsTotal: 'Ukupno',
    additionalTitle: 'Dodatne informacije',
    additionalUpdatedTitle: 'Ažurirano',
    additionalSizeTitle: 'Veličina',
    additionalInstallTitle: 'Instalacije',
    additionalVersionTitle: 'Trenutna verzija',
    additionalAgeTitle: 'Dob',
    additionalDeveloperTitle: 'Programer',
    detailsSupport: 'Podrška za aplikaciju',
    detailsPrivacyPolicy: 'Pravila privatnosti',
    googlePlayRefund: 'Pravila povrata Google Playa',
    googlePlayVAT: 'Sve cijene uključuju PDV.',
    googlePlayGames: 'Igre',
    googlePlayApps: 'Aplikacije',
    googlePlaySearch: 'Pretraži',
    googlePlayBooks: 'Knjige',
  },
  sr: {
    infoChoice: 'Избор уредника',
    infoWishList: 'Додај у листу жеља',
    infoAge: 'Године',
    infoRatedFor: 'Оцењено за',
    infoReviews: 'рецензије',
    appAvailability: 'Ова апликација је доступна за све ваше уређаје',
    infoOpen: 'Отвори',
    infoLoading: 'Учитавање...',
    infoDownloads: 'Преузимања',
    infoInstall: 'Инсталирај',
    addToWishlist: 'Додај у листу жеља',
    infoDownload: 'Преузми',
    infoEditorsChoice: 'Избор уредника',
    infoAboutGame: 'О овој игри',
    infoDataSafety: 'Безбедност података',
    infoDataSafetyDescription:
      'Безбедност почиње разумевањем начина на који програмери прикупљају и деле ваше податке. Практике приватности и безбедности могу да се разликују у зависности од ваше употребе, региона и година. Програмер је пружио ове информације и може их ажурирати током времена.',
    infoDataSharing: 'Нема дељења података са трећим странама',
    infoDataSharingLearnMore1: 'Сазнај више',
    infoDataSharingLearnMore2: 'о томе како програмери пријављују дељење',
    infoDataCollecting: 'Нема прикупљања података',
    infoDataCollectingLearnMore1: 'Сазнај више',
    infoDataCollectingLearnMore2: 'о томе како програмери пријављују прикупљање',
    infoSeeDetails: 'Погледај детаље',
    descriptionTitle: 'О апликацији',
    descriptionMore: 'Више...',
    descriptionLess: 'Мање',
    changesTitle: 'Шта је ново',
    chartsTitle: 'Оцене и рецензије',
    ratingsDescription: 'Оцене и рецензије су потврђене и потичу од људи који користе исти тип уређаја као и ви',
    ratingLikes: 'људи је сматрало ово корисним',
    ratingQuestion: 'Да ли је ова рецензија била корисна?',
    ratingQuestionYes: 'Да',
    ratingQuestionNo: 'Не',
    ratingAllReviews: 'Погледај све рецензије',
    chartsTotal: 'Укупно',
    additionalTitle: 'Додатне информације',
    additionalUpdatedTitle: 'Ажурирано',
    additionalSizeTitle: 'Величина',
    additionalInstallTitle: 'Инсталације',
    additionalVersionTitle: 'Тренутна верзија',
    additionalAgeTitle: 'Године',
    additionalDeveloperTitle: 'Програмер',
    detailsSupport: 'Подршка за апликацију',
    detailsPrivacyPolicy: 'Политика приватности',
    googlePlayRefund: 'Политика поврата Google Play-а',
    googlePlayVAT: 'Све цене укључују ПДВ.',
    googlePlayGames: 'Игре',
    googlePlayApps: 'Апликације',
    googlePlaySearch: 'Претрага',
    googlePlayBooks: 'Књиге',
  },
  ca: {
    infoChoice: "Selecció de l'editor",
    infoWishList: 'Afegeix a la llista de desitjos',
    infoAge: 'Edat',
    infoRatedFor: 'Classificat per a',
    infoReviews: 'ressenyes',
    appAvailability: 'Aquesta aplicació està disponible per a tots els teus dispositius',
    infoOpen: 'Obrir',
    infoLoading: 'Carregant...',
    infoDownloads: 'Descàrregues',
    infoInstall: 'Instal·lar',
    addToWishlist: 'Afegeix a la llista de desitjos',
    infoDownload: 'Descarregar',
    infoEditorsChoice: "Selecció de l'editor",
    infoAboutGame: 'Sobre aquest joc',
    infoDataSafety: 'Seguretat de dades',
    infoDataSafetyDescription:
      'La seguretat comença entenent com els desenvolupadors recopilen i comparteixen les teves dades. Les pràctiques de privadesa i seguretat poden variar segons el teu ús, regió i edat. El desenvolupador ha proporcionat aquesta informació i pot actualitzar-la amb el temps.',
    infoDataSharing: 'Sense compartir dades amb tercers',
    infoDataSharingLearnMore1: 'Més informació',
    infoDataSharingLearnMore2: 'sobre com els desenvolupadors declaren la compartició',
    infoDataCollecting: 'No es recullen dades',
    infoDataCollectingLearnMore1: 'Més informació',
    infoDataCollectingLearnMore2: 'sobre com els desenvolupadors declaren la recopilació',
    infoSeeDetails: 'Veure detalls',
    descriptionTitle: "Sobre l'aplicació",
    descriptionMore: 'Més...',
    descriptionLess: 'Menys',
    changesTitle: 'Novetats',
    chartsTitle: 'Valoracions i ressenyes',
    ratingsDescription:
      'Les valoracions i ressenyes estan verificades i provenen de persones que utilitzen el mateix tipus de dispositiu que tu',
    ratingLikes: 'persones ho han trobat útil',
    ratingQuestion: 'Aquesta ressenya ha estat útil?',
    ratingQuestionYes: 'Sí',
    ratingQuestionNo: 'No',
    ratingAllReviews: 'Veure totes les ressenyes',
    chartsTotal: 'Total',
    additionalTitle: 'Informació addicional',
    additionalUpdatedTitle: 'Actualitzat',
    additionalSizeTitle: 'Mida',
    additionalInstallTitle: 'Instal·lacions',
    additionalVersionTitle: 'Versió actual',
    additionalAgeTitle: 'Edat',
    additionalDeveloperTitle: 'Desenvolupador',
    detailsSupport: "Suport de l'aplicació",
    detailsPrivacyPolicy: 'Política de privacitat',
    googlePlayRefund: 'Política de reemborsament de Google Play',
    googlePlayVAT: 'Tots els preus inclouen IVA.',
    googlePlayGames: 'Jocs',
    googlePlayApps: 'Aplicacions',
    googlePlaySearch: 'Cerca',
    googlePlayBooks: 'Llibres',
  },
  lt: {
    infoChoice: 'Redaktoriaus pasirinkimas',
    infoWishList: 'Įtraukti į norų sąrašą',
    infoAge: 'Amžius',
    infoRatedFor: 'Įvertinta',
    infoReviews: 'apžvalgos',
    appAvailability: 'Ši programa pasiekiama visuose jūsų įrenginiuose',
    infoOpen: 'Atidaryti',
    infoLoading: 'Įkeliama...',
    infoDownloads: 'Atsiuntimai',
    infoInstall: 'Įdiegti',
    addToWishlist: 'Įtraukti į norų sąrašą',
    infoDownload: 'Atsisiųsti',
    infoEditorsChoice: 'Redaktoriaus pasirinkimas',
    infoAboutGame: 'Apie šį žaidimą',
    infoDataSafety: 'Duomenų sauga',
    infoDataSafetyDescription:
      'Sauga prasideda nuo supratimo, kaip kūrėjai renka ir dalijasi jūsų duomenimis. Privatumo ir saugumo praktika gali skirtis priklausomai nuo naudojimo, regiono ir amžiaus. Kūrėjas pateikė šią informaciją ir gali ją atnaujinti laikui bėgant.',
    infoDataSharing: 'Jokie duomenys nesidalijami su trečiosiomis šalimis',
    infoDataSharingLearnMore1: 'Sužinoti daugiau',
    infoDataSharingLearnMore2: 'apie tai, kaip kūrėjai deklaruoja dalijimąsi',
    infoDataCollecting: 'Duomenys nerenkami',
    infoDataCollectingLearnMore1: 'Sužinoti daugiau',
    infoDataCollectingLearnMore2: 'apie tai, kaip kūrėjai deklaruoja rinkimą',
    infoSeeDetails: 'Žiūrėti detales',
    descriptionTitle: 'Apie programą',
    descriptionMore: 'Daugiau...',
    descriptionLess: 'Mažiau',
    changesTitle: 'Kas naujo',
    chartsTitle: 'Įvertinimai ir apžvalgos',
    ratingsDescription:
      'Įvertinimai ir apžvalgos yra patvirtinti ir pateikti žmonių, naudojančių tokio pat tipo įrenginį kaip ir jūs',
    ratingLikes: 'žmonių manė, kad tai naudinga',
    ratingQuestion: 'Ar ši apžvalga buvo naudinga?',
    ratingQuestionYes: 'Taip',
    ratingQuestionNo: 'Ne',
    ratingAllReviews: 'Žiūrėti visas apžvalgas',
    chartsTotal: 'Iš viso',
    additionalTitle: 'Papildoma informacija',
    additionalUpdatedTitle: 'Atnaujinta',
    additionalSizeTitle: 'Dydis',
    additionalInstallTitle: 'Įdiegimai',
    additionalVersionTitle: 'Dabartinė versija',
    additionalAgeTitle: 'Amžius',
    additionalDeveloperTitle: 'Kūrėjas',
    detailsSupport: 'Programos palaikymas',
    detailsPrivacyPolicy: 'Privatumo politika',
    googlePlayRefund: 'Google Play grąžinimo politika',
    googlePlayVAT: 'Visos kainos įskaičiuoja PVM.',
    googlePlayGames: 'Žaidimai',
    googlePlayApps: 'Programos',
    googlePlaySearch: 'Paieška',
    googlePlayBooks: 'Knygos',
  },
  sl: {
    infoChoice: 'Izbira urednika',
    infoWishList: 'Dodaj na seznam želja',
    infoAge: 'Starost',
    infoRatedFor: 'Ocenjeno za',
    infoReviews: 'mnenja',
    appAvailability: 'Ta aplikacija je na voljo za vse vaše naprave',
    infoOpen: 'Odpri',
    infoLoading: 'Nalaganje...',
    infoDownloads: 'Prenosi',
    infoInstall: 'Namesti',
    addToWishlist: 'Dodaj na seznam želja',
    infoDownload: 'Prenesi',
    infoEditorsChoice: 'Izbira urednika',
    infoAboutGame: 'O tej igri',
    infoDataSafety: 'Varnost podatkov',
    infoDataSafetyDescription:
      'Varnost se začne z razumevanjem, kako razvijalci zbirajo in delijo vaše podatke. Prakse zasebnosti in varnosti se lahko razlikujejo glede na vašo uporabo, regijo in starost. Razvijalec je posredoval te informacije in jih lahko sčasoma posodobi.',
    infoDataSharing: 'Podatki se ne delijo s tretjimi osebami',
    infoDataSharingLearnMore1: 'Več o tem',
    infoDataSharingLearnMore2: 'kako razvijalci prijavljajo deljenje',
    infoDataCollecting: 'Podatki se ne zbirajo',
    infoDataCollectingLearnMore1: 'Več o tem',
    infoDataCollectingLearnMore2: 'kako razvijalci prijavljajo zbiranje',
    infoSeeDetails: 'Poglej podrobnosti',
    descriptionTitle: 'O aplikaciji',
    descriptionMore: 'Več...',
    descriptionLess: 'Manj',
    changesTitle: 'Kaj je novega',
    chartsTitle: 'Ocene in mnenja',
    ratingsDescription:
      'Ocene in mnenja so preverjene in prihajajo od ljudi, ki uporabljajo enako vrsto naprave kot vi',
    ratingLikes: 'ljudi je menilo, da je to koristno',
    ratingQuestion: 'Ali je bila ta ocena koristna?',
    ratingQuestionYes: 'Da',
    ratingQuestionNo: 'Ne',
    ratingAllReviews: 'Poglej vsa mnenja',
    chartsTotal: 'Skupaj',
    additionalTitle: 'Dodatne informacije',
    additionalUpdatedTitle: 'Posodobljeno',
    additionalSizeTitle: 'Velikost',
    additionalInstallTitle: 'Namestitve',
    additionalVersionTitle: 'Trenutna različica',
    additionalAgeTitle: 'Starost',
    additionalDeveloperTitle: 'Razvijalec',
    detailsSupport: 'Podpora za aplikacijo',
    detailsPrivacyPolicy: 'Politika zasebnosti',
    googlePlayRefund: 'Politika vračila Google Play',
    googlePlayVAT: 'Vse cene vključujejo DDV.',
    googlePlayGames: 'Igre',
    googlePlayApps: 'Aplikacije',
    googlePlaySearch: 'Iskanje',
    googlePlayBooks: 'Knjige',
  },
  et: {
    infoChoice: 'Toimetaja valik',
    infoWishList: 'Lisa soovinimekirja',
    infoAge: 'Vanus',
    infoRatedFor: 'Hinnatud',
    infoReviews: 'arvustused',
    appAvailability: 'See rakendus on saadaval kõigis teie seadmetes',
    infoOpen: 'Ava',
    infoLoading: 'Laadimine...',
    infoDownloads: 'Allalaadimised',
    infoInstall: 'Installi',
    addToWishlist: 'Lisa soovinimekirja',
    infoDownload: 'Lae alla',
    infoEditorsChoice: 'Toimetaja valik',
    infoAboutGame: 'Mängust',
    infoDataSafety: 'Andmete turvalisus',
    infoDataSafetyDescription:
      'Turvalisus algab arusaamast, kuidas arendajad koguvad ja jagavad teie andmeid. Andmete privaatsus ja turvapoliitikad võivad erineda vastavalt kasutamisele, piirkonnale ja vanusele. Arendaja esitas selle teabe ja võib seda aja jooksul uuendada.',
    infoDataSharing: 'Kolmandate osapooltega andmeid ei jagata',
    infoDataSharingLearnMore1: 'Lisateave',
    infoDataSharingLearnMore2: 'selle kohta, kuidas arendajad jagamist deklareerivad',
    infoDataCollecting: 'Andmeid ei koguta',
    infoDataCollectingLearnMore1: 'Lisateave',
    infoDataCollectingLearnMore2: 'selle kohta, kuidas arendajad kogumist deklareerivad',
    infoSeeDetails: 'Vaata üksikasju',
    descriptionTitle: 'Rakendusest',
    descriptionMore: 'Rohkem...',
    descriptionLess: 'Vähem',
    changesTitle: 'Mis on uut',
    chartsTitle: 'Hinnangud ja arvustused',
    ratingsDescription:
      'Hinnangud ja arvustused on kinnitatud ning pärinevad inimestelt, kes kasutavad sama tüüpi seadet nagu teie',
    ratingLikes: 'inimest leidis selle kasulikuks',
    ratingQuestion: 'Kas see arvustus oli kasulik?',
    ratingQuestionYes: 'Jah',
    ratingQuestionNo: 'Ei',
    ratingAllReviews: 'Vaata kõiki arvustusi',
    chartsTotal: 'Kokku',
    additionalTitle: 'Lisateave',
    additionalUpdatedTitle: 'Uuendatud',
    additionalSizeTitle: 'Suurus',
    additionalInstallTitle: 'Installimised',
    additionalVersionTitle: 'Praegune versioon',
    additionalAgeTitle: 'Vanus',
    additionalDeveloperTitle: 'Arendaja',
    detailsSupport: 'Rakenduse tugi',
    detailsPrivacyPolicy: 'Privaatsuspoliitika',
    googlePlayRefund: 'Google Play tagasimaksepoliitika',
    googlePlayVAT: 'Kõik hinnad sisaldavad KM-i.',
    googlePlayGames: 'Mängud',
    googlePlayApps: 'Rakendused',
    googlePlaySearch: 'Otsing',
    googlePlayBooks: 'Raamatud',
  },
  lv: {
    infoChoice: 'Redaktora izvēle',
    infoWishList: 'Pievienot vēlmju sarakstam',
    infoAge: 'Vecums',
    infoRatedFor: 'Novērtēts',
    infoReviews: 'atsauksmes',
    appAvailability: 'Šī lietotne ir pieejama visās jūsu ierīcēs',
    infoOpen: 'Atvērt',
    infoLoading: 'Notiek ielāde...',
    infoDownloads: 'Lejupielādes',
    infoInstall: 'Instalēt',
    addToWishlist: 'Pievienot vēlmju sarakstam',
    infoDownload: 'Lejupielādēt',
    infoEditorsChoice: 'Redaktora izvēle',
    infoAboutGame: 'Par šo spēli',
    infoDataSafety: 'Datu drošība',
    infoDataSafetyDescription:
      'Drošība sākas ar izpratni par to, kā izstrādātāji vāc un kopīgo jūsu datus. Privātuma un drošības prakse var atšķirties atkarībā no lietošanas, reģiona un vecuma. Izstrādātājs sniedza šo informāciju un var to atjaunināt.',
    infoDataSharing: 'Dati netiek kopīgoti ar trešajām pusēm',
    infoDataSharingLearnMore1: 'Uzzināt vairāk',
    infoDataSharingLearnMore2: 'par to, kā izstrādātāji deklarē kopīgošanu',
    infoDataCollecting: 'Dati netiek vākti',
    infoDataCollectingLearnMore1: 'Uzzināt vairāk',
    infoDataCollectingLearnMore2: 'par to, kā izstrādātāji deklarē vākšanu',
    infoSeeDetails: 'Skatīt detaļas',
    descriptionTitle: 'Par lietotni',
    descriptionMore: 'Vairāk...',
    descriptionLess: 'Mazāk',
    changesTitle: 'Kas jauns',
    chartsTitle: 'Vērtējumi un atsauksmes',
    ratingsDescription:
      'Vērtējumi un atsauksmes ir pārbaudīti un no cilvēkiem, kas izmanto tāda paša tipa ierīci kā jūs',
    ratingLikes: 'cilvēkiem tas šķita noderīgi',
    ratingQuestion: 'Vai šī atsauksme bija noderīga?',
    ratingQuestionYes: 'Jā',
    ratingQuestionNo: 'Nē',
    ratingAllReviews: 'Skatīt visas atsauksmes',
    chartsTotal: 'Kopā',
    additionalTitle: 'Papildu informācija',
    additionalUpdatedTitle: 'Atjaunināts',
    additionalSizeTitle: 'Izmērs',
    additionalInstallTitle: 'Instalācijas',
    additionalVersionTitle: 'Pašreizējā versija',
    additionalAgeTitle: 'Vecums',
    additionalDeveloperTitle: 'Izstrādātājs',
    detailsSupport: 'Lietotnes atbalsts',
    detailsPrivacyPolicy: 'Privātuma politika',
    googlePlayRefund: 'Google Play atmaksas politika',
    googlePlayVAT: 'Visas cenas ietver PVN.',
    googlePlayGames: 'Spēles',
    googlePlayApps: 'Lietotnes',
    googlePlaySearch: 'Meklēt',
    googlePlayBooks: 'Grāmatas',
  },
  ms: {
    infoChoice: 'Pilihan Editor',
    infoWishList: 'Tambah ke Senarai Hajat',
    infoAge: 'Umur',
    infoRatedFor: 'Dinilai untuk',
    infoReviews: 'ulasan',
    appAvailability: 'Apl ini tersedia untuk semua peranti anda',
    infoOpen: 'Buka',
    infoLoading: 'Memuatkan...',
    infoDownloads: 'Muat turun',
    infoInstall: 'Pasang',
    addToWishlist: 'Tambah ke senarai hajat',
    infoDownload: 'Muat turun',
    infoEditorsChoice: 'Pilihan Editor',
    infoAboutGame: 'Tentang permainan ini',
    infoDataSafety: 'Keselamatan data',
    infoDataSafetyDescription:
      'Keselamatan bermula dengan memahami bagaimana pembangun mengumpul dan berkongsi data anda. Amalan privasi dan keselamatan data mungkin berbeza berdasarkan penggunaan, rantau dan umur. Pembangun menyediakan maklumat ini dan boleh mengemas kini dari semasa ke semasa.',
    infoDataSharing: 'Tiada data dikongsi dengan pihak ketiga',
    infoDataSharingLearnMore1: 'Ketahui lebih lanjut',
    infoDataSharingLearnMore2: 'tentang cara pembangun mengisytiharkan perkongsian',
    infoDataCollecting: 'Tiada data dikumpul',
    infoDataCollectingLearnMore1: 'Ketahui lebih lanjut',
    infoDataCollectingLearnMore2: 'tentang cara pembangun mengisytiharkan pengumpulan',
    infoSeeDetails: 'Lihat butiran',
    descriptionTitle: 'Tentang Apl',
    descriptionMore: 'Lagi...',
    descriptionLess: 'Kurang',
    changesTitle: 'Apa yang Baharu',
    chartsTitle: 'Penilaian dan Ulasan',
    ratingsDescription:
      'Penilaian dan ulasan disahkan dan daripada orang yang menggunakan jenis peranti yang sama seperti anda',
    ratingLikes: 'orang mendapati ini berguna',
    ratingQuestion: 'Adakah ulasan ini berguna?',
    ratingQuestionYes: 'Ya',
    ratingQuestionNo: 'Tidak',
    ratingAllReviews: 'Lihat semua ulasan',
    chartsTotal: 'Jumlah',
    additionalTitle: 'Maklumat Tambahan',
    additionalUpdatedTitle: 'Dikemas kini',
    additionalSizeTitle: 'Saiz',
    additionalInstallTitle: 'Pemasangan',
    additionalVersionTitle: 'Versi Semasa',
    additionalAgeTitle: 'Umur',
    additionalDeveloperTitle: 'Pembangun',
    detailsSupport: 'Sokongan apl',
    detailsPrivacyPolicy: 'Dasar privasi',
    googlePlayRefund: 'Dasar bayaran balik Google Play',
    googlePlayVAT: 'Semua harga termasuk VAT.',
    googlePlayGames: 'Permainan',
    googlePlayApps: 'Apl',
    googlePlaySearch: 'Cari',
    googlePlayBooks: 'Buku',
  },
  is: {
    infoChoice: 'Val ritstjóra',
    infoWishList: 'Bæta við óskalista',
    infoAge: 'Aldur',
    infoRatedFor: 'Metið fyrir',
    infoReviews: 'umsagnir',
    appAvailability: 'Þetta forrit er fáanlegt fyrir öll tækin þín',
    infoOpen: 'Opna',
    infoLoading: 'Hleð...',
    infoDownloads: 'Niðurhal',
    infoInstall: 'Setja upp',
    addToWishlist: 'Bæta á óskalista',
    infoDownload: 'Sækja',
    infoEditorsChoice: 'Val ritstjóra',
    infoAboutGame: 'Um þetta leik',
    infoDataSafety: 'Öryggi gagna',
    infoDataSafetyDescription:
      'Öryggi byrjar með því að skilja hvernig forritarar safna og deila gögnum þínum. Persónuverndar- og öryggisvenjur geta verið mismunandi eftir notkun, svæði og aldri. Forritarinn gaf upp þessar upplýsingar og getur uppfært þær með tímanum.',
    infoDataSharing: 'Engin gögn deild með þriðja aðila',
    infoDataSharingLearnMore1: 'Frekari upplýsingar',
    infoDataSharingLearnMore2: 'um hvernig forritarar lýsa yfir deilingu',
    infoDataCollecting: 'Engin gögn safnað',
    infoDataCollectingLearnMore1: 'Frekari upplýsingar',
    infoDataCollectingLearnMore2: 'um hvernig forritarar lýsa yfir söfnun',
    infoSeeDetails: 'Sjá nánar',
    descriptionTitle: 'Um forritið',
    descriptionMore: 'Meira...',
    descriptionLess: 'Minna',
    changesTitle: 'Nýjungar',
    chartsTitle: 'Einkunnir og umsagnir',
    ratingsDescription: 'Einkunnir og umsagnir eru staðfestar og frá fólki sem notar sama tegund tækis og þú',
    ratingLikes: 'fannst þetta gagnlegt',
    ratingQuestion: 'Var þessi umsögn gagnleg?',
    ratingQuestionYes: 'Já',
    ratingQuestionNo: 'Nei',
    ratingAllReviews: 'Sjá allar umsagnir',
    chartsTotal: 'Samtals',
    additionalTitle: 'Viðbótarupplýsingar',
    additionalUpdatedTitle: 'Uppfært',
    additionalSizeTitle: 'Stærð',
    additionalInstallTitle: 'Uppsetningar',
    additionalVersionTitle: 'Núverandi útgáfa',
    additionalAgeTitle: 'Aldur',
    additionalDeveloperTitle: 'Forritari',
    detailsSupport: 'Forritastuðningur',
    detailsPrivacyPolicy: 'Persónuverndarstefna',
    googlePlayRefund: 'Endurgreiðslustefna Google Play',
    googlePlayVAT: 'Allar verð innihalda VSK.',
    googlePlayGames: 'Leikir',
    googlePlayApps: 'Forrit',
    googlePlaySearch: 'Leita',
    googlePlayBooks: 'Bækur',
  },
};
